const account={url:{css:"./1.0/account.css",token:"/account/jwt/token",validate:"/account/jwt/validate"},build:{}};account.build.elementWithText=function(elementType,displayValue){let element=document.createElement(elementType);return element.appendChild(document.createTextNode(displayValue)),element},account.build.elementWithAttributes=function(elementToMake,elementAttributes,displayText){let element=document.createElement(elementToMake);for(let prop in elementAttributes)element.setAttribute(prop,elementAttributes[prop]);return(displayText||0===displayText)&&element.appendChild(document.createTextNode(displayText)),element},account.build.createSvg=function(svgPaths,svgWidth,svgHeight,svgClass){svgWidth||(svgWidth=48),svgHeight||(svgHeight=48),svgViewBox="0 0 "+svgWidth+" "+svgHeight,svgWidth+="px",svgHeight+="px";var svg=document.createElementNS("http://www.w3.org/2000/svg","svg");if(svg.setAttribute("viewBox",svgViewBox),svg.setAttribute("x","0px"),svg.setAttribute("y","0px"),svg.setAttribute("width",svgWidth),svg.setAttribute("height",svgHeight),svg.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xlink","http://www.w3.org/1999/xlink"),svgClass&&svg.setAttribute("class",svgClass),svgPaths){for(var i=0;i<svgPaths.length;i++){var path=document.createElementNS("http://www.w3.org/2000/svg","path");path.setAttributeNS(null,"d",svgPaths[i].d),path.setAttributeNS(null,"fill",svgPaths[i].fill),svg.appendChild(path)}return svg}},account.cookies={getItem:function(sKey){return sKey&&decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*"+encodeURIComponent(sKey).replace(/[\-\.\+\*]/g,"\\$&")+"\\s*\\=\\s*([^;]*).*$)|^.*$"),"$1"))||null},setItem:function(sKey,sValue,vEnd,sPath,sDomain,bSecure){if(!sKey||/^(?:expires|max\-age|path|domain|secure)$/i.test(sKey))return!1;var sExpires="";if(vEnd)switch(vEnd.constructor){case Number:sExpires=vEnd===1/0?"; expires=Fri, 31 Dec 9999 23:59:59 GMT":"; max-age="+vEnd;break;case String:sExpires="; expires="+vEnd;break;case Date:sExpires="; expires="+vEnd.toUTCString()}return document.cookie=encodeURIComponent(sKey)+"="+sValue+sExpires+(sDomain?"; domain="+sDomain:"")+(sPath?"; path="+sPath:"")+(bSecure?"; secure":""),!0},removeItem:function(sKey,sPath,sDomain){return!!this.hasItem(sKey)&&(document.cookie=encodeURIComponent(sKey)+"=; expires=Thu, 01 Jan 1970 00:00:00 GMT"+(sDomain?"; domain="+sDomain:"")+(sPath?"; path="+sPath:""),!0)},hasItem:function(sKey){return!(!sKey||/^(?:expires|max\-age|path|domain|secure)$/i.test(sKey))&&new RegExp("(?:^|;\\s*)"+encodeURIComponent(sKey).replace(/[\-\.\+\*]/g,"\\$&")+"\\s*\\=").test(document.cookie)},keys:function(){for(var aKeys=document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g,"").split(/\s*(?:\=[^;]*)?;\s*/),nLen=aKeys.length,nIdx=0;nIdx<nLen;nIdx++)aKeys[nIdx]=decodeURIComponent(aKeys[nIdx]);return aKeys}},account.svg={},account.svg.logo={paths:[{fill:"#E6B42A",d:"M0 35.5c0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7S0 40.3 0 35.5z"},{fill:"#FFFFFF",d:"M3 12v10.9c0 2.6 1.1 3.9 3.4 3.9 1 0 1.9-0.3 2.7-0.9 0.8-0.6 1.4-1.2 1.6-2v-12h3v17h-3v-2.4c-0.3 0.7-1 1.3-2 1.8 -1 0.6-2 0.8-3 0.8 -1.9 0-3.3-0.5-4.3-1.6S0 24.9 0 22.9V11.7H3L3 12 3 12zM17.2 14.4h-2V12h2V8.4l3-1.2v4.7h4.7v2.4h-4.7v8.5c0 1.4 0.2 2.4 0.7 3.1 0.5 0.6 1.3 0.9 2.3 0.9 0.8 0 1.6-0.2 2.4-0.6l0.4 2.7c-1.3 0.3-2.6 0.5-4.1 0.5 -1.3 0-2.5-0.5-3.4-1.5 -0.9-1-1.4-2.3-1.4-3.8L17.2 14.4 17.2 14.4zM36.8 27.1c-1.2 1.5-3.1 2.3-5.6 2.3 -1.3 0-2.5-0.5-3.5-1.5 -1-1-1.5-2.2-1.5-3.6 0-1.7 0.8-3.2 2.3-4.4 1.5-1.2 3.4-1.8 5.8-1.8 0.6 0 1.4 0.1 2.2 0.4 0-2.8-1.2-4.1-3.7-4.1 -1.9 0-3.3 0.5-4.4 1.5l-1.3-2.5c0.6-0.5 1.4-0.9 2.4-1.2 1-0.3 2-0.5 2.9-0.5 2.5 0 4.3 0.6 5.4 1.7 1.1 1.1 1.7 2.9 1.7 5.4v6.1c0 1.5 0.4 2.5 1.3 3v1.5c-1.2 0-2.2-0.2-2.8-0.5C37.5 28.5 37.1 27.9 36.8 27.1zM36.5 20.7c-1-0.2-1.6-0.3-2-0.3 -1.5 0-2.8 0.4-3.7 1.2 -1 0.8-1.4 1.7-1.4 2.8 0 1.8 1 2.7 3.1 2.7 1.5 0 2.9-0.7 4.1-2.2L36.5 20.7 36.5 20.7zM53 29.1V18.4c0-1.3-0.3-2.3-0.9-3 -0.6-0.7-1.5-1.1-2.6-1.1 -0.7 0-1.5 0.2-2.2 0.6 -0.7 0.4-1.3 0.9-1.7 1.5v12.7h-3v-23l3-1V14c0.4-0.6 1.1-1.1 1.9-1.6 0.9-0.4 1.8-0.6 2.8-0.6 1.8 0 3.2 0.6 4.2 1.8 1 1.2 1.5 2.8 1.5 4.9v10.7L53 29.1 53 29.1z"},{fill:"#FFFFFF",d:"M16.9 49l1.4-2.1c1.5 1 3 1.5 4.3 1.5 1.2 0 2.1-0.2 2.8-0.6s1-0.9 1-1.5c0-1.2-0.9-1.8-2.6-1.8 -0.3 0-0.8 0.1-1.6 0.2 -0.8 0.1-1.4 0.2-1.8 0.2 -2.1 0-3.2-0.8-3.2-2.4 0-0.5 0.2-0.9 0.7-1.3 0.5-0.4 1.1-0.7 1.8-0.9 -2.1-1-3.1-2.7-3.1-5.1 0-1.6 0.5-2.9 1.6-3.9 1.1-1 2.4-1.6 4-1.6 1.5 0 2.6 0.3 3.4 0.9l1.3-1.6 1.7 1.6L27 31.8c0.7 0.9 1 2 1 3.5 0 1.5-0.5 2.8-1.4 3.8 -0.9 1-2.2 1.6-3.7 1.8l-2.2 0.2c-0.3 0-0.6 0.1-1 0.3 -0.4 0.2-0.7 0.4-0.7 0.7 0 0.4 0.5 0.6 1.4 0.6 0.4 0 1-0.1 1.9-0.2 0.8-0.1 1.5-0.2 1.9-0.2 1.5 0 2.6 0.4 3.4 1.1 0.8 0.7 1.2 1.7 1.2 2.9 0 1.4-0.6 2.5-1.8 3.3 -1.2 0.8-2.8 1.3-4.7 1.3 -1 0-2-0.2-3-0.5C18.4 49.9 17.6 49.5 16.9 49zM22.5 31.8c-0.9 0-1.7 0.3-2.2 1 -0.6 0.6-0.9 1.4-0.9 2.4 0 1 0.3 1.9 0.8 2.6 0.6 0.7 1.3 1 2.3 1 0.9 0 1.7-0.3 2.2-1 0.5-0.7 0.8-1.5 0.8-2.6 0-0.9-0.3-1.7-0.9-2.4C24.1 32.2 23.4 31.8 22.5 31.8zM28.8 37.4c0-2.3 0.6-4.2 1.9-5.6 1.2-1.4 2.9-2.1 4.9-2.1 2.1 0 3.8 0.7 5 2 1.2 1.4 1.8 3.2 1.8 5.7 0 2.4-0.6 4.3-1.8 5.7 -1.2 1.4-2.8 2.1-4.9 2.1 -2.1 0-3.8-0.7-5-2.1C29.4 41.7 28.8 39.8 28.8 37.4zM31.5 37.4c0 3.7 1.3 5.6 4 5.6 1.2 0 2.2-0.5 2.9-1.5s1.1-2.4 1.1-4.1c0-3.7-1.3-5.5-4-5.5 -1.2 0-2.2 0.5-2.9 1.5C31.9 34.3 31.5 35.7 31.5 37.4zM49.5 45.2h-0.7L42.4 30h2.9l3.9 10.4 4-10.4H56L49.5 45.2z"}]},account.svg.logo.element=account.build.createSvg(account.svg.logo.paths,56,56),account.svg.icons={closePaths:[{fill:"#444",d:"M23,10.4L21.6,9L16,14.6L10.4,9L9,10.4l5.6,5.6L9,21.6l1.4,1.4l5.6-5.6l5.6,5.6l1.4-1.4L17.4,16L23,10.4z"}]},account.svg.closeIcon=account.build.createSvg(account.svg.icons.closePaths,32,32),account.el={},account.buildModal=function(cancelable){account.el.modal=account.build.elementWithAttributes("div",{class:"account-modal account-initialized",id:"account-modal",role:"dialog"},null),account.el.overlay=account.build.elementWithAttributes("div",{id:"account-overlay"},null),account.el.form=account.build.elementWithAttributes("form",{id:"account-form",method:"post",role:"form"},null),account.el.header=account.build.elementWithAttributes("div",{id:"account-header"},null),account.el.logo=account.build.elementWithAttributes("div",{id:"account-logo"},null),account.el.logo.appendChild(account.svg.logo.element),account.el.cancelButton=account.build.elementWithAttributes("button",{type:"button",id:"account-cancel",title:"Cancel"},null),account.el.cancelButton.appendChild(account.svg.closeIcon),account.el.theatre=account.build.elementWithAttributes("div",{id:"account-theatre"},null),account.el.fieldset=account.build.elementWithAttributes("fieldset",{name:"account-logine"},null),account.el.legend=account.build.elementWithText("legend","Log in with your Utah.gov Account"),account.el.labelUsername=account.build.elementWithAttributes("label",{for:"account-user"},"Username"),account.el.inputUsername=account.build.elementWithAttributes("input",{type:"text",id:"account-user",name:"username",autocomplete:"username",required:"required",tabindex:"1"},"Username"),account.el.labelPassword=account.build.elementWithAttributes("label",{for:"account-pass"},"Password"),account.el.inputPassword=account.build.elementWithAttributes("input",{type:"password",id:"account-pass",name:"password",autocomplete:"password",required:"required",tabindex:"2"},"Username"),account.el.message=account.build.elementWithAttributes("div",{id:"account-message"},null),account.el.recovery=account.build.elementWithAttributes("div",{id:"account-recovery"},"Forgot your: "),account.el.recoveryUsername=account.build.elementWithAttributes("a",{href:"/account/forgotUsername.html",id:"forgotUsername"},"Username"),account.el.recoveryPassword=account.build.elementWithAttributes("a",{href:"/account/forgotPassword.html",id:"forgotPassword"},"Password"),account.el.footer=account.build.elementWithAttributes("div",{id:"account-footer"},null),account.el.buttonCreateAccount=account.build.elementWithAttributes("button",{type:"button",class:"account-btn--create",tabindex:"4"},"Create Account"),account.el.buttonLogin=account.build.elementWithAttributes("button",{type:"submit",class:"account-btn--login",tabindex:"3"},"Log In"),document.body.appendChild(account.el.overlay),document.body.appendChild(account.el.modal),account.el.modal.appendChild(account.el.form),account.el.header.appendChild(account.el.logo),cancelable&&account.el.header.appendChild(account.el.cancelButton),account.el.form.appendChild(account.el.header),account.el.form.appendChild(account.el.theatre),account.el.theatre.appendChild(account.el.fieldset),account.el.fieldset.appendChild(account.el.legend),account.el.fieldset.appendChild(account.el.labelUsername),account.el.fieldset.appendChild(account.el.inputUsername),account.el.fieldset.appendChild(account.el.labelPassword),account.el.fieldset.appendChild(account.el.inputPassword),account.el.theatre.appendChild(account.el.message),account.el.theatre.appendChild(account.el.recovery),account.el.recovery.appendChild(account.el.recoveryUsername),account.el.recovery.innerHTML+=" / ",account.el.recovery.appendChild(account.el.recoveryPassword),account.el.recovery.innerHTML+=" ?",account.el.form.appendChild(account.el.footer),account.el.footer.appendChild(account.el.buttonCreateAccount),account.el.footer.appendChild(account.el.buttonLogin)},account.storage={},account.storage.key="uiijwt",account.storage.set=function(jwt){localStorage.setItem(account.storage.key,jwt)},account.storage.get=function(){return localStorage.getItem(account.storage.key)},account.storage.remove=function(){localStorage.removeItem(account.storage.key)},account.storage.check=function(){return null!==localStorage.getItem(account.storage.key)},account.storage.userdata={key:"uiidata"},account.storage.userdata.set=function(userData){sessionStorage.setItem(account.storage.userdata.key,JSON.stringify(userData))},account.storage.userdata.get=function(){let userData=sessionStorage.getItem(account.storage.userdata.key);return JSON.parse(userData)},account.storage.userdata.remove=function(){sessionStorage.removeItem(account.storage.userdata.key)},account.ajax={},account.ajax.login=function(user,pass,callback){let creds=JSON.stringify({username:user,password:pass}),xhr=new XMLHttpRequest;xhr.withCredentials=!0,xhr.addEventListener("readystatechange",(function(){this.readyState===this.DONE&&"function"==typeof callback&&callback(xhr)})),xhr.open("POST",account.url.token),xhr.responseType="json",xhr.setRequestHeader("content-type","application/JSON"),xhr.setRequestHeader("x-requested-with","XMLHttpRequest"),xhr.send(creds)},account.ajax.validate=function(callback){let xhr=new XMLHttpRequest;xhr.withCredentials=!0,xhr.addEventListener("readystatechange",(function(){this.readyState===this.DONE&&(400===this.status&&(account.storage.remove(),account.storage.userdata.remove()),200===this.status&&account.storage.userdata.set(this.response.userData),"function"==typeof callback&&callback(this))})),xhr.open("GET",account.url.validate),xhr.responseType="json",xhr.setRequestHeader("content-type","application/JSON"),xhr.setRequestHeader("x-requested-with","XMLHttpRequest");let uiijwt=account.storage.get();null!==uiijwt&&xhr.setRequestHeader("Authorization","Bearer "+uiijwt),xhr.send()},account.message={},account.message.create=function(type,message){switch(type){case"error":account.el.message.classList.add("account-error"),account.el.logo.classList.add("account-invalid");break;case"success":account.el.message.classList.add("account-success"),account.el.logo.classList.add("account-valid");break;default:account.el.message.classList="",account.el.logo.classList=""}account.el.message.innerText=message},account.message.destroy=function(){account.el.message.classList="",account.el.message.innerText="",account.el.logo.classList=""},account.submitLogin=function(e){e.preventDefault(),account.inputs.disable();let u=account.el.form.username.value,p=account.el.form.password.value;null!=u&&null!=p&&account.ajax.login(u,p,(function(data){"string"==typeof data&&(data=JSON.parse(data));let response=data.response,status=data.status;account.compute(status,response.token)}))},account.inputs={},account.inputs.enable=function(){account.el.inputUsername.disabled=!1,account.el.inputPassword.disabled=!1},account.inputs.disable=function(){account.el.inputUsername.disabled=!0,account.el.inputPassword.disabled=!0},account.compute=function(status,jwt){switch(account.message.destroy(),status){case 503:account.message.create("error","Service Unavailable!"),account.storage.remove(),account.inputs.enable(),account.el.overlay.classList.add("account-servererror");break;case 500:account.message.create("error","Internal Server Error!"),account.storage.remove(),account.inputs.enable(),account.el.overlay.classList.add("account-servererror");break;case 400:account.message.create("error","Invalid Login"),account.storage.remove(),account.inputs.enable(),account.makeMilkShake();break;case 404:account.inputs.enable(),account.message.create("error","Service Unavailable");break;case 200:account.message.create("success","Valid Login!"),account.storage.set(jwt),account.success()}},account.success=function(){account.destroyModal(1e3,(function(){"function"==typeof account.successCallback?account.successCallback():"string"==typeof account.successCallback&&(window.location=account.successCallback)}))},account.failure=function(){account.destroyModal(1e3,(function(){"function"==typeof account.failureCallback?account.failureCallback():"string"==typeof account.failureCallback&&(window.location=account.failureCallback)}))},account.destroyModal=function(ms,cb){ms=ms||1e3,cb=cb||!1,account.el.modal.classList.add("account-destroy"),account.el.overlay.classList.add("account-destroy"),setTimeout((function(){document.body.removeChild(account.el.modal),document.body.removeChild(account.el.overlay),0!=cb&&cb()}),ms)},account.makeMilkShake=function(){account.el.modal.classList.contains("account-initialized")&&account.el.modal.classList.remove("account-initialized"),account.el.modal.classList.contains("account-motion-shake")||(account.el.modal.classList.add("account-motion-shake"),setTimeout((function(){account.el.modal.classList.remove("account-motion-shake")}),1e3))},account.listeners=function(){account.el.form.addEventListener("submit",account.submitLogin,!1),account.el.buttonCreateAccount.addEventListener("click",(function(){var curPath=window.location;account.cookies.setItem("returnToUrl",curPath,null,"/",null,!0),window.location="/account/newAccount.html"}),!1),account.el.cancelButton.addEventListener("click",(function(){account.destroyModal()}),!1)},account.validate=account.ajax.validate,account.addCss=function(){document.getElementsByTagName("head")[0];let css=account.build.elementWithAttributes("link",{rel:"stylesheet",href:account.url.css},null);document.head.appendChild(css)},account.hasToken=account.storage.check,account.init=function(success,failure,cancelable){null!==success&&(account.successCallback=success),null!==failure&&(account.failureCallback=failure),!1!==cancelable&&(cancelable=!0),account.buildModal(cancelable),account.listeners(),window.scrollTo(0,0)},account.login=account.init;
//# sourceMappingURL=account.min.js.map

/*\
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  Revision #3 - July 13th, 2017
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
|*|  https://developer.mozilla.org/User:fusionchess
|*|  https://github.com/madmurphy/cookies.js
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path[, domain]])
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/

var docCookies = {
  getItem: function (sKey) {
    if (!sKey) { return null; }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          /*
          Note: Despite officially defined in RFC 6265, the use of `max-age` is not compatible with any
          version of Internet Explorer, Edge and some mobile browsers. Therefore passing a number to
          the end parameter might not work as expected. A possible solution might be to convert the the
          relative time to an absolute time. For instance, replacing the previous line with:
          */
          /*
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; expires=" + (new Date(vEnd * 1e3 + Date.now())).toUTCString();
          */
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
  }
};
var Chart=function(){"use strict";function t(t,e){return"string"==typeof t?(e||document).querySelector(t):t||null}function e(t){var e=t.getBoundingClientRect();return{top:e.top+(document.documentElement.scrollTop||document.body.scrollTop),left:e.left+(document.documentElement.scrollLeft||document.body.scrollLeft)}}function i(t){var e=t.getBoundingClientRect();return e.top>=0&&e.left>=0&&e.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&e.right<=(window.innerWidth||document.documentElement.clientWidth)}function a(t){var e=window.getComputedStyle(t),i=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight);return t.clientWidth-i}function s(t,e,i){var a=void 0,s=void 0;return t<=e?(s=t,0===(a=e-t)&&(s-=a=.01*i)):(s=e,0===(a=t-e)&&(a=.01*i)),[a,s]}function n(t,e){return"string"==typeof t?(e||document).querySelector(t):t||null}function r(t,e){var i=document.createElementNS("http://www.w3.org/2000/svg",t);for(var a in e){var s=e[a];if("inside"===a)n(s).appendChild(i);else if("around"===a){var r=n(s);r.parentNode.insertBefore(i,r),i.appendChild(r)}else"styles"===a?"object"===(void 0===s?"undefined":W(s))&&Object.keys(s).map(function(t){i.style[t]=s[t]}):("className"===a&&(a="class"),"innerHTML"===a?i.textContent=s:i.setAttribute(a,s))}return i}function o(t,e){return r("linearGradient",{inside:t,id:e,x1:0,x2:0,y1:0,y2:1})}function l(t,e,i,a){return r("stop",{inside:t,style:"stop-color: "+i,offset:e,"stop-opacity":a})}function h(t,e,i,a){return r("svg",{className:e,inside:t,width:i,height:a})}function u(t){return r("defs",{inside:t})}function c(t,e){return r("g",{className:e,inside:t,transform:arguments.length>2&&void 0!==arguments[2]?arguments[2]:""})}function _(t){return r("path",{className:arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",d:t,styles:{stroke:arguments.length>2&&void 0!==arguments[2]?arguments[2]:"none",fill:arguments.length>3&&void 0!==arguments[3]?arguments[3]:"none"}})}function p(t,e){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a="path-fill-gradient-"+e,s=o(t,a),n=[1,.6,.2];return i&&(n=[.4,.2,0]),l(s,"0%",e,n[0]),l(s,"50%",e,n[1]),l(s,"100%",e,n[2]),a}function d(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"none",n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},o={className:t,x:e,y:i,width:a,height:a,fill:s};return Object.keys(n).map(function(t){o[t]=n[t]}),r("rect",o)}function v(t,e,i,a){return r("text",{className:t,x:e,y:i,dy:".32em",innerHTML:a})}function f(t,e,i,a,s,n){var o=r("line",{x1:0,x2:0,y1:0,y2:t}),l=r("text",{className:a,x:0,y:e,dy:".71em",innerHTML:i}),h=r("g",{className:"tick "+s,transform:"translate("+n+", 0)"});return h.appendChild(o),h.appendChild(l),h}function m(t,e,i,a,s,n,o){var l=arguments.length>7&&void 0!==arguments[7]&&arguments[7],h=r("line",{className:"dashed"===(arguments.length>8&&void 0!==arguments[8]?arguments[8]:"")?"dashed":"",x1:t,x2:e,y1:0,y2:0}),u=r("text",{className:s,x:i,y:0,dy:".32em",innerHTML:a+""}),c=r("g",{className:"tick "+n,transform:"translate(0, "+o+")","stroke-opacity":1});return l&&(h.style.stroke="rgba(27, 31, 35, 0.6)"),c.appendChild(h),c.appendChild(u),c}function g(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"linear",s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:void 0,n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},r=t.cloneNode(!0),o=t.cloneNode(!0);for(var l in e){var h=void 0;h="transform"===l?document.createElementNS("http://www.w3.org/2000/svg","animateTransform"):document.createElementNS("http://www.w3.org/2000/svg","animate");var u=n[l]||t.getAttribute(l),c=e[l],_={attributeName:l,from:u,to:c,begin:"0s",dur:i/1e3+"s",values:u+";"+c,keySplines:V[a],keyTimes:"0;1",calcMode:"spline",fill:"freeze"};s&&(_.type=s);for(var p in _)h.setAttribute(p,_[p]);r.appendChild(h),s?o.setAttribute(l,"translate("+c+")"):o.setAttribute(l,c)}return[r,o]}function y(t,e){t.style.transform=e,t.style.webkitTransform=e,t.style.msTransform=e,t.style.mozTransform=e,t.style.oTransform=e}function x(t,e){var i=[],a=[];e.map(function(t){var e=t[0],s=e.unit.parentNode,n=void 0,r=void 0;t[0]=e.unit;var o=g.apply(void 0,X(t)),l=Y(o,2);n=l[0],r=l[1],i.push(r),a.push([n,s]),s.replaceChild(n,e.unit),e.array?e.array[e.index]=r:e.object[e.key]=r});var s=t.cloneNode(!0);return a.map(function(t,a){t[1].replaceChild(i[a],t[0]),e[a][0]=i[a]}),s}function k(t){if(0===t)return[0,0];if(isNaN(t))return{mantissa:-6755399441055744,exponent:972};var e=t>0?1:-1;if(!isFinite(t))return{mantissa:4503599627370496*e,exponent:972};t=Math.abs(t);var i=Math.floor(Math.log10(t));return[e*(t/Math.pow(10,i)),i]}function w(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=Math.ceil(t),a=Math.floor(e),s=i-a,n=s,r=1;s>5&&(s%2!=0&&(s=++i-a),n=s/2,r=2),s<=2&&(r=s/(n=4)),0===s&&(n=5,r=1);for(var o=[],l=0;l<=n;l++)o.push(a+r*l);return o}function b(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=k(t),a=Y(i,2),s=a[0],n=a[1],r=e?e/Math.pow(10,n):0,o=w(s=s.toFixed(6),r);return o=o.map(function(t){return t*Math.pow(10,n)})}function C(t){function e(t,e){for(var i=b(t),a=i[1]-i[0],s=0,n=1;s<e;n++)s+=a,i.unshift(-1*s);return i}var i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=Math.max.apply(Math,X(t)),s=Math.min.apply(Math,X(t)),n=[];if(a>=0&&s>=0)k(a)[1],n=i?b(a,s):b(a);else if(a>0&&s<0){var r=Math.abs(s);a>=r?(k(a)[1],n=e(a,r)):(k(r)[1],n=e(r,a).map(function(t){return-1*t}))}else if(a<=0&&s<=0){var o=Math.abs(s),l=Math.abs(a);k(o)[1],n=(n=i?b(o,l):b(o)).reverse().map(function(t){return-1*t})}return n}function A(t,e){for(var i=Math.max.apply(Math,X(t)),a=1/(e-1),s=[],n=0;n<e;n++){var r=i*(a*n);s.push(r)}return s}function M(t,e){return e.filter(function(e){return e<t}).length}function O(t){return parseFloat(t.toFixed(2))}function N(t,e){if(t.length!==e.length)return!1;var i=!0;return t.map(function(t,a){e[a]!==t&&(i=!1)}),i}function L(t,e){return(t+"").length*e}function P(t){return t>255?255:t<0?0:t}function S(t,e){var i=Z(t),a=!1;"#"==i[0]&&(i=i.slice(1),a=!0);var s=parseInt(i,16),n=P((s>>16)+e),r=P((s>>8&255)+e),o=P((255&s)+e);return(a?"#":"")+(o|r<<8|n<<16).toString(16)}function T(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)}function z(t){var e=new Date(t);return e.setMinutes(e.getMinutes()-e.getTimezoneOffset()),e}function j(t){var e=t.getDate(),i=t.getMonth()+1;return[(e>9?"":"0")+e,(i>9?"":"0")+i,t.getFullYear()].join("-")}function E(t,e){return Math.ceil(D(t,e)/7)}function D(t,e){return(z(e)-z(t))/864e5}function H(t,e){t.setDate(t.getDate()+e)}function F(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"line",e=arguments[1];return _t[t]?new _t[t](e):new rt(e)}!function(t,e){if("undefined"==typeof document)return e;t=t||"";var i=document.head||document.getElementsByTagName("head")[0],a=document.createElement("style");a.type="text/css",i.appendChild(a),a.styleSheet?a.styleSheet.cssText=t:a.appendChild(document.createTextNode(t))}('.chart-container{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif}.chart-container .graph-focus-margin{margin:0 5%}.chart-container>.title{margin-top:25px;margin-left:25px;text-align:left;font-weight:400;font-size:12px;color:#6c7680}.chart-container .graphics{margin-top:10px;padding-top:10px;padding-bottom:10px;position:relative}.chart-container .graph-stats-group{-ms-flex-pack:distribute;-webkit-box-flex:1;-ms-flex:1;flex:1}.chart-container .graph-stats-container,.chart-container .graph-stats-group{display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:space-around}.chart-container .graph-stats-container{-ms-flex-pack:distribute;padding-top:10px}.chart-container .graph-stats-container .stats{padding-bottom:15px}.chart-container .graph-stats-container .stats-title{color:#8d99a6}.chart-container .graph-stats-container .stats-value{font-size:20px;font-weight:300}.chart-container .graph-stats-container .stats-description{font-size:12px;color:#8d99a6}.chart-container .graph-stats-container .graph-data .stats-value{color:#98d85b}.chart-container .axis,.chart-container .chart-label{font-size:11px;fill:#555b51}.chart-container .axis line,.chart-container .chart-label line{stroke:#dadada}.chart-container .percentage-graph .progress{margin-bottom:0}.chart-container .data-points circle{stroke:#fff;stroke-width:2}.chart-container .path-group path{fill:none;stroke-opacity:1;stroke-width:2px}.chart-container line.dashed{stroke-dasharray:5,3}.chart-container .tick.x-axis-label{display:block}.chart-container .tick .specific-value{text-anchor:start}.chart-container .tick .y-value-text{text-anchor:end}.chart-container .tick .x-value-text{text-anchor:middle}.chart-container .progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.chart-container .progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#36414c;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.chart-container .graph-svg-tip{position:absolute;z-index:1;padding:10px;font-size:12px;color:#959da5;text-align:center;background:rgba(0,0,0,.8);border-radius:3px}.chart-container .graph-svg-tip ol,.chart-container .graph-svg-tip ul{padding-left:0;display:-webkit-box;display:-ms-flexbox;display:flex}.chart-container .graph-svg-tip ul.data-point-list li{min-width:90px;-webkit-box-flex:1;-ms-flex:1;flex:1;font-weight:600}.chart-container .graph-svg-tip strong{color:#dfe2e5;font-weight:600}.chart-container .graph-svg-tip .svg-pointer{position:absolute;height:5px;margin:0 0 0 -5px;content:" ";border:5px solid transparent;border-top-color:rgba(0,0,0,.8)}.chart-container .graph-svg-tip.comparison{padding:0;text-align:left;pointer-events:none}.chart-container .graph-svg-tip.comparison .title{display:block;padding:10px;margin:0;font-weight:600;line-height:1;pointer-events:none}.chart-container .graph-svg-tip.comparison ul{margin:0;white-space:nowrap;list-style:none}.chart-container .graph-svg-tip.comparison li{display:inline-block;padding:5px 10px}.chart-container .indicator,.chart-container .indicator-right{background:none;font-size:12px;vertical-align:middle;font-weight:700;color:#6c7680}.chart-container .indicator i{content:"";display:inline-block;height:8px;width:8px;border-radius:8px}.chart-container .indicator:before,.chart-container .indicator i{margin:0 4px 0 0}.chart-container .indicator-right:after{margin:0 0 0 4px}',void 0);var W="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},B=(function(){function t(t){this.value=t}function e(e){function i(t,e){return new Promise(function(i,s){var o={key:t,arg:e,resolve:i,reject:s,next:null};r?r=r.next=o:(n=r=o,a(t,e))})}function a(i,n){try{var r=e[i](n),o=r.value;o instanceof t?Promise.resolve(o.value).then(function(t){a("next",t)},function(t){a("throw",t)}):s(r.done?"return":"normal",r.value)}catch(t){s("throw",t)}}function s(t,e){switch(t){case"return":n.resolve({value:e,done:!0});break;case"throw":n.reject(e);break;default:n.resolve({value:e,done:!1})}(n=n.next)?a(n.key,n.arg):r=null}var n,r;this._invoke=i,"function"!=typeof e.return&&(this.return=void 0)}"function"==typeof Symbol&&Symbol.asyncIterator&&(e.prototype[Symbol.asyncIterator]=function(){return this}),e.prototype.next=function(t){return this._invoke("next",t)},e.prototype.throw=function(t){return this._invoke("throw",t)},e.prototype.return=function(t){return this._invoke("return",t)}}(),function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}),I=function(){function t(t,e){for(var i=0;i<e.length;i++){var a=e[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(t,a.key,a)}}return function(e,i,a){return i&&t(e.prototype,i),a&&t(e,a),e}}(),q=function t(e,i,a){null===e&&(e=Function.prototype);var s=Object.getOwnPropertyDescriptor(e,i);if(void 0===s){var n=Object.getPrototypeOf(e);return null===n?void 0:t(n,i,a)}if("value"in s)return s.value;var r=s.get;if(void 0!==r)return r.call(a)},R=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)},U=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e},Y=function(){function t(t,e){var i=[],a=!0,s=!1,n=void 0;try{for(var r,o=t[Symbol.iterator]();!(a=(r=o.next()).done)&&(i.push(r.value),!e||i.length!==e);a=!0);}catch(t){s=!0,n=t}finally{try{!a&&o.return&&o.return()}finally{if(s)throw n}}return i}return function(e,i){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),X=function(t){if(Array.isArray(t)){for(var e=0,i=Array(t.length);e<t.length;e++)i[e]=t[e];return i}return Array.from(t)};t.create=function(e,i){var a=document.createElement(e);for(var s in i){var n=i[s];if("inside"===s)t(n).appendChild(a);else if("around"===s){var r=t(n);r.parentNode.insertBefore(a,r),a.appendChild(r)}else"styles"===s?"object"===(void 0===n?"undefined":W(n))&&Object.keys(n).map(function(t){a.style[t]=n[t]}):s in a?a[s]=n:a.setAttribute(s,n)}return a},t.bind=function(t,e){if(t)for(var i in e){var a=e[i];i.split(/\s+/).forEach(function(e){t.addEventListener(e,a)})}},t.unbind=function(t,e){if(t)for(var i in e){var a=e[i];i.split(/\s+/).forEach(function(e){t.removeEventListener(e,a)})}},t.fire=function(t,e,i){var a=document.createEvent("HTMLEvents");a.initEvent(e,!0,!0);for(var s in i)a[s]=i[s];return t.dispatchEvent(a)};var J=function(){var t=function(t,e,i){this.totalHeight=t,this.zeroLine=e,this.avgUnitWidth=i};return t.prototype={bar:function(t,e,i,a,n,o,l){var h=this.avgUnitWidth-i.spaceWidth,u=h/l,c=t-h/2+u*o,_=s(e,this.zeroLine,this.totalHeight),p=Y(_,2),d=p[0];return r("rect",{className:"bar mini",style:"fill: "+a,"data-point-index":n,x:c,y:p[1],width:u,height:d})},dot:function(t,e,i,a,s){return r("circle",{style:"fill: "+a,"data-point-index":s,cx:t,cy:e,r:i.radius})}},t}(),G=function(){var t=function(t,e,i,a){this.totalHeight=t,this.totalWidth=e,this.avgUnitWidth=a,this.zeroLine=i};return t.prototype={bar:function(t,e,i,a,n){var r=e-this.avgUnitWidth/4,o=this.avgUnitWidth/2/n,l=s(i,this.zeroLine,this.totalHeight),h=Y(l,2);return e=r+o*a,[t,{width:o,height:h[0],x:e,y:h[1]},350,"easein"]},dot:function(t,e,i){return[t,{cx:e,cy:i},350,"easein"]},path:function(t,e){var i=[],a=[{unit:t.path,object:t,key:"path"},{d:"M"+e},350,"easein"];if(i.push(a),t.regionPath){var s="0,"+this.zeroLine+"L",n="L"+this.totalWidth+", "+this.zeroLine,r=[{unit:t.regionPath,object:t,key:"regionPath"},{d:"M"+s+e+n},350,"easein"];i.push(r)}return i}},t}(),V={ease:"0.25 0.1 0.25 1",linear:"0 0 1 1",easein:"0.1 0.8 0.2 1",easeout:"0 0 0.58 1",easeinout:"0.42 0 0.58 1"},$=function(){function e(t){var i=t.parent,a=void 0===i?null:i,s=t.colors,n=void 0===s?[]:s;B(this,e),this.parent=a,this.colors=n,this.title_name="",this.title_value="",this.list_values=[],this.title_value_first=0,this.x=0,this.y=0,this.top=0,this.left=0,this.setup()}return I(e,[{key:"setup",value:function(){this.make_tooltip()}},{key:"refresh",value:function(){this.fill(),this.calc_position()}},{key:"make_tooltip",value:function(){var e=this;this.container=t.create("div",{inside:this.parent,className:"graph-svg-tip comparison",innerHTML:'<span class="title"></span>\n\t\t\t\t<ul class="data-point-list"></ul>\n\t\t\t\t<div class="svg-pointer"></div>'}),this.hide_tip(),this.title=this.container.querySelector(".title"),this.data_point_list=this.container.querySelector(".data-point-list"),this.parent.addEventListener("mouseleave",function(){e.hide_tip()})}},{key:"fill",value:function(){var e=this,i=void 0;i=this.title_value_first?"<strong>"+this.title_value+"</strong>"+this.title_name:this.title_name+"<strong>"+this.title_value+"</strong>",this.title.innerHTML=i,this.data_point_list.innerHTML="",this.list_values.map(function(i,a){var s=e.colors[a]||"black",n=t.create("li",{styles:{"border-top":"3px solid "+s},innerHTML:'<strong style="display: block;">'+(0===i.value||i.value?i.value:"")+"</strong>\n\t\t\t\t\t"+(i.title?i.title:"")});e.data_point_list.appendChild(n)})}},{key:"calc_position",value:function(){var t=this.container.offsetWidth;this.top=this.y-this.container.offsetHeight,this.left=this.x-t/2;var e=this.parent.offsetWidth-t,i=this.container.querySelector(".svg-pointer");if(this.left<0)i.style.left="calc(50% - "+-1*this.left+"px)",this.left=0;else if(this.left>e){var a="calc(50% + "+(this.left-e)+"px)";i.style.left=a,this.left=e}else i.style.left="50%"}},{key:"set_values",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"",a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"",s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;this.title_name=i,this.title_value=a,this.list_values=s,this.x=t,this.y=e,this.title_value_first=n,this.refresh()}},{key:"hide_tip",value:function(){this.container.style.top="0px",this.container.style.left="0px",this.container.style.opacity="0"}},{key:"show_tip",value:function(){this.container.style.top=this.top+"px",this.container.style.left=this.left+"px",this.container.style.opacity="1"}}]),e}(),K={"light-blue":"#7cd6fd",blue:"#5e64ff",violet:"#743ee2",red:"#ff5858",orange:"#ffa00a",yellow:"#feef72",green:"#28a745","light-green":"#98d85b",purple:"#b554ff",magenta:"#ffa3ef",black:"#36114C",grey:"#bdd3e6","light-grey":"#f0f4f7","dark-grey":"#b8c2cc"},Q=["light-blue","blue","violet","red","orange","yellow","green","light-green","purple","magenta"],Z=function(t){return K[t]||t},tt=["line","scatter","bar","percentage","heatmap","pie"],et={bar:["line","scatter","percentage","pie"],line:["scatter","bar","percentage","pie"],pie:["line","scatter","percentage","bar"],scatter:["line","bar","percentage","pie"],percentage:["bar","line","scatter","pie"],heatmap:[]},it={bar:["line","scatter"],line:["scatter","bar"],pie:["percentage"],scatter:["line","bar"],percentage:["pie"],heatmap:[]},at=function(){function e(t){var i=t.height,a=void 0===i?240:i,s=t.title,n=void 0===s?"":s,r=t.subtitle,o=void 0===r?"":r,l=t.colors,h=void 0===l?[]:l,u=t.summary,c=void 0===u?[]:u,_=t.is_navigable,p=void 0===_?0:_,d=t.has_legend,v=void 0===d?0:d,f=t.type,m=void 0===f?"":f,g=t.parent,y=t.data;B(this,e),this.raw_chart_args=arguments[0],this.parent="string"==typeof g?document.querySelector(g):g,this.title=n,this.subtitle=o,this.data=y,this.specific_values=y.specific_values||[],this.summary=c,this.is_navigable=p,this.is_navigable&&(this.current_index=0),this.has_legend=v,this.setColors(h,m),this.set_margins(a)}return I(e,[{key:"get_different_chart",value:function(t){if(t!==this.type){tt.includes(t)||console.error("'"+t+"' is not a valid chart type."),et[this.type].includes(t)||console.error("'"+this.type+"' chart cannot be converted to a '"+t+"' chart.");var e=it[this.type].includes(t);return new pt({parent:this.raw_chart_args.parent,title:this.title,data:this.raw_chart_args.data,type:t,height:this.raw_chart_args.height,colors:e?this.colors:void 0})}}},{key:"setColors",value:function(t,e){this.colors=t;var i="percentage"===e||"pie"===e?this.data.labels:this.data.datasets;(!this.colors||i&&this.colors.length<i.length)&&(this.colors=Q),this.colors=this.colors.map(function(t){return Z(t)})}},{key:"set_margins",value:function(t){this.base_height=t,this.height=t-40,this.translate_x=60,this.translate_y=10}},{key:"setup",value:function(){if(!this.parent)return void console.error("No parent element to render on was provided.");this.validate_and_prepare_data()&&(this.bind_window_events(),this.refresh(!0))}},{key:"validate_and_prepare_data",value:function(){return!0}},{key:"bind_window_events",value:function(){var t=this;window.addEventListener("resize",function(){return t.refresh()}),window.addEventListener("orientationchange",function(){return t.refresh()})}},{key:"refresh",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.setup_base_values(),this.set_width(),this.setup_container(),this.setup_components(),this.setup_values(),this.setup_utils(),this.make_graph_components(t),this.make_tooltip(),this.summary.length>0?this.show_custom_summary():this.show_summary(),this.is_navigable&&this.setup_navigation(t)}},{key:"set_width",value:function(){var t=0;this.specific_values.map(function(e){var i=L(e.title+"",8);i>t&&(t=i-40)}),this.base_width=a(this.parent)-t,this.width=this.base_width-2*this.translate_x}},{key:"setup_base_values",value:function(){}},{key:"setup_container",value:function(){this.container=t.create("div",{className:"chart-container",innerHTML:'<h6 class="title">'+this.title+'</h6>\n\t\t\t\t<h6 class="sub-title uppercase">'+this.subtitle+'</h6>\n\t\t\t\t<div class="frappe-chart graphics"></div>\n\t\t\t\t<div class="graph-stats-container"></div>'}),this.parent.innerHTML="",this.parent.appendChild(this.container),this.chart_wrapper=this.container.querySelector(".frappe-chart"),this.stats_wrapper=this.container.querySelector(".graph-stats-container"),this.make_chart_area(),this.make_draw_area()}},{key:"make_chart_area",value:function(){return this.svg=h(this.chart_wrapper,"chart",this.base_width,this.base_height),this.svg_defs=u(this.svg),this.svg}},{key:"make_draw_area",value:function(){this.draw_area=c(this.svg,this.type+"-chart","translate("+this.translate_x+", "+this.translate_y+")")}},{key:"setup_components",value:function(){}},{key:"make_tooltip",value:function(){this.tip=new $({parent:this.chart_wrapper,colors:this.colors}),this.bind_tooltip()}},{key:"show_summary",value:function(){}},{key:"show_custom_summary",value:function(){var e=this;this.summary.map(function(i){var a=t.create("div",{className:"stats",innerHTML:'<span class="indicator">\n\t\t\t\t\t<i style="background:'+i.color+'"></i>\n\t\t\t\t\t'+i.title+": "+i.value+"\n\t\t\t\t</span>"});e.stats_wrapper.appendChild(a)})}},{key:"setup_navigation",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.make_overlay(),e&&(this.bind_overlay(),document.addEventListener("keydown",function(e){i(t.chart_wrapper)&&("37"==(e=e||window.event).keyCode?t.on_left_arrow():"39"==e.keyCode?t.on_right_arrow():"38"==e.keyCode?t.on_up_arrow():"40"==e.keyCode?t.on_down_arrow():"13"==e.keyCode&&t.on_enter_key())}))}},{key:"make_overlay",value:function(){}},{key:"bind_overlay",value:function(){}},{key:"bind_units",value:function(){}},{key:"on_left_arrow",value:function(){}},{key:"on_right_arrow",value:function(){}},{key:"on_up_arrow",value:function(){}},{key:"on_down_arrow",value:function(){}},{key:"on_enter_key",value:function(){}},{key:"get_data_point",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.current_index,e={index:t},i=this.y[0];return["svg_units","y_tops","values"].map(function(a){var s=a.slice(0,a.length-1);e[s]=i[a][t]}),e.label=this.x[t],e}},{key:"update_current_data_point",value:function(e){(e=parseInt(e))<0&&(e=0),e>=this.x.length&&(e=this.x.length-1),e!==this.current_index&&(this.current_index=e,t.fire(this.parent,"data-select",this.get_data_point()))}},{key:"setup_utils",value:function(){}},{key:"makeDrawAreaComponent",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return c(this.draw_area,t,e)}}]),e}(),st=function(t){function i(t){B(this,i);var e=U(this,(i.__proto__||Object.getPrototypeOf(i)).call(this,t));return e.x=e.data.labels||[],e.y=e.data.datasets||[],e.is_series=t.is_series,e.format_tooltip_y=t.format_tooltip_y,e.format_tooltip_x=t.format_tooltip_x,e.zero_line=e.height,e}return R(i,t),I(i,[{key:"validate_and_prepare_data",value:function(){return!0}},{key:"setup_values",value:function(){this.data.datasets.map(function(t){t.values=t.values.map(function(t){return isNaN(t)?0:t})}),this.setup_x(),this.setup_y()}},{key:"setup_x",value:function(){var t=this;this.set_avg_unit_width_and_x_offset(),this.x_axis_positions&&(this.x_old_axis_positions=this.x_axis_positions.slice()),this.x_axis_positions=this.x.map(function(e,i){return O(t.x_offset+i*t.avg_unit_width)}),this.x_old_axis_positions||(this.x_old_axis_positions=this.x_axis_positions.slice())}},{key:"setup_y",value:function(){this.y_axis_values&&(this.y_old_axis_values=this.y_axis_values.slice());var t=this.get_all_y_values();this.y_sums&&this.y_sums.length>0&&(t=t.concat(this.y_sums)),this.y_axis_values=C(t,"line"===this.type),this.y_old_axis_values||(this.y_old_axis_values=this.y_axis_values.slice());var e=this.y_axis_values,i=e[e.length-1]-e[0];this.multiplier&&(this.old_multiplier=this.multiplier),this.multiplier=this.height/i,this.old_multiplier||(this.old_multiplier=this.multiplier);var a=e[1]-e[0],s=a*this.multiplier,n=void 0;n=e.indexOf(0)>=0?e.indexOf(0):e[0]>0?-1*e[0]/a:-1*e[e.length-1]/a+(e.length-1),this.zero_line&&(this.old_zero_line=this.zero_line),this.zero_line=this.height-n*s,this.old_zero_line||(this.old_zero_line=this.zero_line)}},{key:"setup_components",value:function(){q(i.prototype.__proto__||Object.getPrototypeOf(i.prototype),"setup_components",this).call(this),this.setup_marker_components(),this.setup_aggregation_components(),this.setup_graph_components()}},{key:"setup_marker_components",value:function(){this.y_axis_group=this.makeDrawAreaComponent("y axis"),this.x_axis_group=this.makeDrawAreaComponent("x axis"),this.specific_y_group=this.makeDrawAreaComponent("specific axis")}},{key:"setup_aggregation_components",value:function(){this.sum_group=this.makeDrawAreaComponent("data-points"),this.average_group=this.makeDrawAreaComponent("chart-area")}},{key:"setup_graph_components",value:function(){var t=this;this.svg_units_groups=[],this.y.map(function(e,i){t.svg_units_groups[i]=t.makeDrawAreaComponent("data-points data-points-"+i)})}},{key:"make_graph_components",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.make_y_axis(),this.make_x_axis(),this.draw_graph(t),this.make_y_specifics()}},{key:"make_x_axis",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],i=void 0,a=void 0,s=void 0,n="";if("span"===this.x_axis_mode?(i=-7,a=this.height+15,s=this.height+25):"tick"===this.x_axis_mode&&(i=this.height,a=6,s=9,n="x-axis-label"),this.x_axis_group.setAttribute("transform","translate(0,"+i+")"),e)return void this.make_anim_x_axis(a,s,n);var r=1.5*this.avg_unit_width,o=r/8;this.x_axis_group.textContent="",this.x.map(function(e,i){var l=L(e,8)+2;if(l>r)if(t.is_series){for(var h=1;l/h*2>r;)h++;if(i%h!=0)return}else e=e.slice(0,o-3)+" ...";t.x_axis_group.appendChild(f(a,s,e,"x-value-text",n,t.x_axis_positions[i]))})}},{key:"make_y_axis",value:function(){var t=this;if(arguments.length>0&&void 0!==arguments[0]&&arguments[0])return this.make_anim_y_axis(),void this.make_anim_y_specifics();var e=this.get_y_axis_line_props(),i=Y(e,4),a=i[0],s=i[1],n=i[2],r=i[3];this.y_axis_group.textContent="",this.y_axis_values.map(function(e,i){t.y_axis_group.appendChild(m(r,a,s,e,"y-value-text",n,t.zero_line-e*t.multiplier,0===e&&0!==i))})}},{key:"get_y_axis_line_props",value:function(){if(arguments.length>0&&void 0!==arguments[0]&&arguments[0])return[this.width,this.width+5,"specific-value",0];var t=void 0,e="",i=0;return"span"===this.y_axis_mode?(t=this.width+6,i=-6):"tick"===this.y_axis_mode&&(t=-6,e="y-axis-label"),[t,-9,e,i]}},{key:"draw_graph",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return this.raw_chart_args.hasOwnProperty("init")&&!this.raw_chart_args.init?void this.y.map(function(e,i){e.svg_units=[],t.make_path&&t.make_path(e,i,t.x_axis_positions,e.y_tops,t.colors[i]),t.make_new_units(e,i),t.calc_y_dependencies()}):e?void this.draw_new_graph_and_animate():void this.y.map(function(e,i){e.svg_units=[],t.make_path&&t.make_path(e,i,t.x_axis_positions,e.y_tops,t.colors[i]),t.make_new_units(e,i)})}},{key:"draw_new_graph_and_animate",value:function(){var t=this,e=[];this.y.map(function(i,a){i.y_tops=new Array(i.values.length).fill(t.zero_line),e.push({values:i.values}),i.svg_units=[],t.make_path&&t.make_path(i,a,t.x_axis_positions,i.y_tops,t.colors[a]),t.make_new_units(i,a)}),setTimeout(function(){t.update_values(e)},350)}},{key:"setup_navigation",value:function(t){var e=this;t?setTimeout(function(){q(i.prototype.__proto__||Object.getPrototypeOf(i.prototype),"setup_navigation",e).call(e,t)},500):q(i.prototype.__proto__||Object.getPrototypeOf(i.prototype),"setup_navigation",this).call(this,t)}},{key:"make_new_units",value:function(t,e){this.make_new_units_for_dataset(this.x_axis_positions,t.y_tops,this.colors[e],e,this.y.length)}},{key:"make_new_units_for_dataset",value:function(t,e,i,a,s,n,r,o){n||(n=this.svg_units_groups[a]),r||(r=this.y[a].svg_units),o||(o=this.unit_args),n.textContent="",r.length=0;var l=new J(this.height,this.zero_line,this.avg_unit_width);e.map(function(e,h){var u=l[o.type](t[h],e,o.args,i,h,a,s);n.appendChild(u),r.push(u)}),this.is_navigable&&this.bind_units(r)}},{key:"make_y_specifics",value:function(){var t=this;this.specific_y_group.textContent="",this.specific_values.map(function(e){t.specific_y_group.appendChild(m(0,t.width,t.width+5,e.title.toUpperCase(),"specific-value","specific-value",t.zero_line-e.value*t.multiplier,!1,e.line_type))})}},{key:"bind_tooltip",value:function(){var t=this;this.chart_wrapper.addEventListener("mousemove",function(i){var a=e(t.chart_wrapper),s=i.pageX-a.left-t.translate_x;i.pageY-a.top-t.translate_y<t.height+2*t.translate_y?t.map_tooltip_x_position_and_show(s):t.tip.hide_tip()})}},{key:"map_tooltip_x_position_and_show",value:function(t){var e=this;if(this.y_min_tops){var i=this.x;this.format_tooltip_x&&this.format_tooltip_x(this.x[0])&&(i=this.x.map(function(t){return e.format_tooltip_x(t)}));for(var a=this.format_tooltip_y&&this.format_tooltip_y(this.y[0].values[0]),s=this.x_axis_positions.length-1;s>=0;s--){var n=this.x_axis_positions[s];if(t>n-this.avg_unit_width/2){var r=n+this.translate_x,o=this.y_min_tops[s]+this.translate_y,l=i[s],h=this.y.map(function(t,i){return{title:t.title,value:a?e.format_tooltip_y(t.values[s]):t.values[s],color:e.colors[i]}});this.tip.set_values(r,o,l,"",h),this.tip.show_tip();break}}}}},{key:"show_sums",value:function(){var t=this;this.updating=!0,this.y_sums=new Array(this.x_axis_positions.length).fill(0),this.y.map(function(e){e.values.map(function(e,i){t.y_sums[i]+=e})}),this.update_values(),this.sum_units=[],this.make_new_units_for_dataset(this.x_axis_positions,this.y_sums.map(function(e){return O(t.zero_line-e*t.multiplier)}),"#f0f4f7",0,1,this.sum_group,this.sum_units),this.updating=!1}},{key:"hide_sums",value:function(){this.updating||(this.y_sums=[],this.sum_group.textContent="",this.sum_units=[],this.update_values())}},{key:"show_averages",value:function(){var t=this;this.old_specific_values=this.specific_values.slice(),this.y.map(function(e,i){var a=0;e.values.map(function(t){a+=t});var s=a/e.values.length;t.specific_values.push({title:"AVG "+(i+1),line_type:"dashed",value:s,auto:1})}),this.update_values()}},{key:"hide_averages",value:function(){var t=this;this.old_specific_values=this.specific_values.slice();var e=[];this.specific_values.map(function(t,i){t.auto&&e.unshift(i)}),e.map(function(e){t.specific_values.splice(e,1)}),this.update_values()}},{key:"update_values",value:function(t,e){var i=this;e||(e=this.x),this.elements_to_animate=[],this.updating=!0,this.old_x_values=this.x.slice(),this.old_y_axis_tops=this.y.map(function(t){return t.y_tops.slice()}),this.old_y_values=this.y.map(function(t){return t.values}),this.no_of_extra_pts=e.length-this.x.length,t&&this.y.map(function(e,i){e.values=t[i].values}),e&&(this.x=e),this.setup_x(),this.setup_y(),this.calc_y_dependencies(),this.animator=new G(this.height,this.width,this.zero_line,this.avg_unit_width),N(this.x_old_axis_positions,this.x_axis_positions)||(this.make_x_axis(!0),setTimeout(function(){i.updating||i.make_x_axis()},350)),(!N(this.y_old_axis_values,this.y_axis_values)||this.old_specific_values&&!N(this.old_specific_values,this.specific_values))&&(this.make_y_axis(!0),setTimeout(function(){i.updating||(i.make_y_axis(),i.make_y_specifics())},350)),this.animate_graphs(),this.run_animation(),this.updating=!1}},{key:"add_data_point",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.x.length,a=this.y.map(function(t){return{values:t.values}});a.map(function(e,a){e.values.splice(i,0,t[a])});var s=this.x.slice();s.splice(i,0,e),this.update_values(a,s)}},{key:"remove_data_point",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.x.length-1;if(!(this.x.length<3)){var e=this.y.map(function(t){return{values:t.values}});e.map(function(e){e.values.splice(t,1)});var i=this.x.slice();i.splice(t,1),this.update_values(e,i)}}},{key:"run_animation",value:function(){var t=this,e=x(this.svg,this.elements_to_animate);this.svg.parentNode==this.chart_wrapper&&(this.chart_wrapper.removeChild(this.svg),this.chart_wrapper.appendChild(e)),setTimeout(function(){e.parentNode==t.chart_wrapper&&(t.chart_wrapper.removeChild(e),t.chart_wrapper.appendChild(t.svg))},250)}},{key:"animate_graphs",value:function(){var t=this;this.y.map(function(e,i){var a=t.calc_old_and_new_postions(e,i),s=Y(a,4),n=s[0],r=s[1],o=s[2],l=s[3];t.no_of_extra_pts>=0&&(t.make_path&&t.make_path(e,i,n,r,t.colors[i]),t.make_new_units_for_dataset(n,r,t.colors[i],i,t.y.length)),e.path&&t.animate_path(e,i,n,r,o,l),t.animate_units(e,i,n,r,o,l)}),setTimeout(function(){t.y.map(function(e,i){t.make_path&&t.make_path(e,i,t.x_axis_positions,e.y_tops,t.colors[i]),t.make_new_units(e,i)})},400)}},{key:"animate_path",value:function(t,e,i,a,s,n){var r=n.map(function(t,e){return s[e]+","+t}).join("L");this.elements_to_animate=this.elements_to_animate.concat(this.animator.path(t,r))}},{key:"animate_units",value:function(t,e,i,a,s,n){var r=this,o=this.unit_args.type;t.svg_units.map(function(i,a){void 0!==s[a]&&void 0!==n[a]&&r.elements_to_animate.push(r.animator[o]({unit:i,array:t.svg_units,index:a},s[a],n[a],e,r.y.length))})}},{key:"calc_old_and_new_postions",value:function(t,e){var i=this.x_old_axis_positions.slice(),a=this.x_axis_positions.slice(),s=this.old_y_axis_tops[e].slice(),n=t.y_tops.slice(),r=i[i.length-1],o=s[s.length-1],l=a[a.length-1],h=n[n.length-1];if(this.no_of_extra_pts>=0){var u=new Array(Math.abs(this.no_of_extra_pts)).fill(r),c=new Array(Math.abs(this.no_of_extra_pts)).fill(o);i=i.concat(u),s=s.concat(c)}else{var _=new Array(Math.abs(this.no_of_extra_pts)).fill(l),p=new Array(Math.abs(this.no_of_extra_pts)).fill(h);a=a.concat(_),n=n.concat(p)}return[i,s,a,n]}},{key:"make_anim_x_axis",value:function(t,e,i){var a=this,s=this.x_old_axis_positions,n=this.x_axis_positions,r=this.old_x_values,o=this.x,l=s[s.length-1],h=function(s,n,r){"string"==typeof r&&(r=parseInt(r.substring(0,r.length-1)));var o=f(t,e,s,"x-value-text",i,n);a.x_axis_group.appendChild(o),a.elements_to_animate&&a.elements_to_animate.push([{unit:o,array:[0],index:0},{transform:r+", 0"},350,"easein","translate",{transform:n+", 0"}])};this.x_axis_group.textContent="",this.make_new_axis_anim_lines(s,n,r,o,l,h)}},{key:"make_anim_y_axis",value:function(){var t=this,e=this.y_old_axis_values.map(function(e){return t.zero_line-e*t.multiplier}),i=this.y_axis_values.map(function(e){return t.zero_line-e*t.multiplier}),a=this.y_old_axis_values,s=this.y_axis_values,n=e[e.length-1];this.y_axis_group.textContent="",this.make_new_axis_anim_lines(e,i,a,s,n,this.add_and_animate_y_line.bind(this),this.y_axis_group)}},{key:"make_anim_y_specifics",value:function(){var t=this;this.specific_y_group.textContent="",this.specific_values.map(function(e){t.add_and_animate_y_line(e.title,t.old_zero_line-e.value*t.old_multiplier,t.zero_line-e.value*t.multiplier,0,t.specific_y_group,e.line_type,!0)})}},{key:"make_new_axis_anim_lines",value:function(t,e,i,a,s,n,r){var o=void 0,l=void 0,h=a.length-i.length;if(h>0)o=e.slice(0,t.length),l=a.slice(0,i.length);else{var u=new Array(Math.abs(h)).fill("");l=a.concat(u);var c=new Array(Math.abs(h)).fill(s+"F");o=e.concat(c)}if(l.map(function(e,i){n(e,t[i],o[i],i,r)}),h>0){var _=a.slice(i.length),p=e.slice(t.length);_.map(function(t,e){n(t,s,p[e],e,r)})}}},{key:"add_and_animate_y_line",value:function(t,e,i,a,s,n){var r=arguments.length>6&&void 0!==arguments[6]&&arguments[6],o=!1;"string"==typeof i&&(i=parseInt(i.substring(0,i.length-1)),o=!0);var l={transform:"0, "+i},h={transform:"0, "+e};o&&(l["stroke-opacity"]=0);var u=this.get_y_axis_line_props(r),c=Y(u,4),_=c[0],p=c[1],d=c[2],v=c[3],f=r?"specific-value":"y-value-text",g=m(v,_,p,t=r?(t+"").toUpperCase():t,f,d,e,0===t&&0!==a,n);s.appendChild(g),this.elements_to_animate&&this.elements_to_animate.push([{unit:g,array:[0],index:0},l,350,"easein","translate",h])}},{key:"set_avg_unit_width_and_x_offset",value:function(){this.avg_unit_width=this.width/(this.x.length-1),this.x_offset=0}},{key:"get_all_y_values",value:function(){var t=[];return this.y.map(function(e){t=t.concat(e.values)}),t.concat(this.specific_values.map(function(t){return t.value}))}},{key:"calc_y_dependencies",value:function(){var t=this;this.y_min_tops=new Array(this.x_axis_positions.length).fill(9999),this.y.map(function(e){e.y_tops=e.values.map(function(e){return O(t.zero_line-e*t.multiplier)}),e.y_tops.map(function(e,i){e<t.y_min_tops[i]&&(t.y_min_tops[i]=e)})})}}]),i}(at),nt=function(t){function e(t){B(this,e);var i=U(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.type="bar",i.x_axis_mode=t.x_axis_mode||"tick",i.y_axis_mode=t.y_axis_mode||"span",i.setup(),i}return R(e,t),I(e,[{key:"setup_values",value:function(){q(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"setup_values",this).call(this),this.x_offset=this.avg_unit_width,this.unit_args={type:"bar",args:{spaceWidth:this.avg_unit_width/2}}}},{key:"make_overlay",value:function(){var t=this.x.length-1,e=this.y[0].svg_units[t];this.update_current_data_point(t),this.overlay&&this.overlay.parentNode.removeChild(this.overlay),this.overlay=e.cloneNode(),this.overlay.style.fill="#000000",this.overlay.style.opacity="0.4",this.draw_area.appendChild(this.overlay)}},{key:"bind_overlay",value:function(){var t=this;this.parent.addEventListener("data-select",function(e){t.update_overlay(e.svg_unit)})}},{key:"bind_units",value:function(t){var e=this;t.map(function(t){t.addEventListener("click",function(){var i=t.getAttribute("data-point-index");e.update_current_data_point(i)})})}},{key:"update_overlay",value:function(t){var e=this,i=[];Object.keys(t.attributes).map(function(e){i.push(t.attributes[e])}),i.filter(function(t){return t.specified}).map(function(t){e.overlay.setAttribute(t.name,t.nodeValue)}),this.overlay.style.fill="#000000",this.overlay.style.opacity="0.4"}},{key:"on_left_arrow",value:function(){this.update_current_data_point(this.current_index-1)}},{key:"on_right_arrow",value:function(){this.update_current_data_point(this.current_index+1)}},{key:"set_avg_unit_width_and_x_offset",value:function(){this.avg_unit_width=this.width/(this.x.length+1),this.x_offset=this.avg_unit_width}}]),e}(st),rt=function(t){function e(t){B(this,e);var i=U(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.x_axis_mode=t.x_axis_mode||"span",i.y_axis_mode=t.y_axis_mode||"span",t.hasOwnProperty("show_dots")?i.show_dots=t.show_dots:i.show_dots=1,i.region_fill=t.region_fill,Object.getPrototypeOf(i)!==e.prototype?U(i):(i.dot_radius=t.dot_radius||4,i.heatline=t.heatline,i.type="line",i.setup(),i)}return R(e,t),I(e,[{key:"setup_graph_components",value:function(){this.setup_path_groups(),q(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"setup_graph_components",this).call(this)}},{key:"setup_path_groups",value:function(){var t=this;this.paths_groups=[],this.y.map(function(e,i){t.paths_groups[i]=c(t.draw_area,"path-group path-group-"+i)})}},{key:"setup_values",value:function(){q(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"setup_values",this).call(this),this.unit_args={type:"dot",args:{radius:this.dot_radius}}}},{key:"make_new_units_for_dataset",value:function(t,i,a,s,n,r,o,l){this.show_dots&&q(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"make_new_units_for_dataset",this).call(this,t,i,a,s,n,r,o,l)}},{key:"make_paths",value:function(){var t=this;this.y.map(function(e,i){t.make_path(e,i,t.x_axis_positions,e.y_tops,e.color||t.colors[i])})}},{key:"make_path",value:function(t,e,i,a,s){var n=a.map(function(t,e){return i[e]+","+t}).join("L");if(this.paths_groups[e].textContent="",t.path=_("M"+n,"line-graph-path",s),this.paths_groups[e].appendChild(t.path),this.heatline){var r=p(this.svg_defs,s);t.path.style.stroke="url(#"+r+")"}this.region_fill&&this.fill_region_for_dataset(t,e,s,n)}},{key:"fill_region_for_dataset",value:function(t,e,i,a){var s=p(this.svg_defs,i,!0),n="M0,"+this.zero_line+"L"+a+"L"+this.width+","+this.zero_line;t.regionPath=_(n,"region-fill","none","url(#"+s+")"),this.paths_groups[e].appendChild(t.regionPath)}}]),e}(st),ot=function(t){function e(t){B(this,e);var i=U(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.type="scatter",t.dot_radius?i.dot_radius=t.dot_radius:i.dot_radius=8,i.setup(),i}return R(e,t),I(e,[{key:"setup_graph_components",value:function(){this.setup_path_groups(),q(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"setup_graph_components",this).call(this)}},{key:"setup_path_groups",value:function(){}},{key:"setup_values",value:function(){q(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"setup_values",this).call(this),this.unit_args={type:"dot",args:{radius:this.dot_radius}}}},{key:"make_paths",value:function(){}},{key:"make_path",value:function(){}}]),e}(rt),lt=function(i){function a(t){B(this,a);var e=U(this,(a.__proto__||Object.getPrototypeOf(a)).call(this,t));return e.type="percentage",e.max_slices=10,e.max_legend_points=6,e.setup(),e}return R(a,i),I(a,[{key:"make_chart_area",value:function(){this.chart_wrapper.className+=" graph-focus-margin",this.chart_wrapper.style.marginTop="45px",this.stats_wrapper.className+=" graph-focus-margin",this.stats_wrapper.style.marginBottom="30px",this.stats_wrapper.style.paddingTop="0px"}},{key:"make_draw_area",value:function(){this.chart_div=t.create("div",{className:"div",inside:this.chart_wrapper}),this.chart=t.create("div",{className:"progress-chart",inside:this.chart_div})}},{key:"setup_components",value:function(){this.percentage_bar=t.create("div",{className:"progress",inside:this.chart})}},{key:"setup_values",value:function(){var t=this;this.slice_totals=[];var e=this.data.labels.map(function(e,i){var a=0;return t.data.datasets.map(function(t){a+=t.values[i]}),[a,e]}).filter(function(t){return t[0]>0}),i=e;if(e.length>this.max_slices){e.sort(function(t,e){return e[0]-t[0]}),i=e.slice(0,this.max_slices-1);var a=0;e.slice(this.max_slices-1).map(function(t){a+=t[0]}),i.push([a,"Rest"]),this.colors[this.max_slices-1]="grey"}this.labels=[],i.map(function(e){t.slice_totals.push(e[0]),t.labels.push(e[1])}),this.legend_totals=this.slice_totals.slice(0,this.max_legend_points)}},{key:"make_graph_components",value:function(){var e=this;this.grand_total=this.slice_totals.reduce(function(t,e){return t+e},0),this.slices=[],this.slice_totals.map(function(i,a){var s=t.create("div",{className:"progress-bar",inside:e.percentage_bar,styles:{background:e.colors[a],width:100*i/e.grand_total+"%"}});e.slices.push(s)})}},{key:"bind_tooltip",value:function(){var t=this;this.slices.map(function(i,a){i.addEventListener("mouseenter",function(){var s=e(t.chart_wrapper),n=e(i),r=n.left-s.left+i.offsetWidth/2,o=n.top-s.top-6,l=(t.formatted_labels&&t.formatted_labels.length>0?t.formatted_labels[a]:t.labels[a])+": ",h=(100*t.slice_totals[a]/t.grand_total).toFixed(1);t.tip.set_values(r,o,l,h+"%"),t.tip.show_tip()})})}},{key:"show_summary",value:function(){var e=this,i=this.formatted_labels&&this.formatted_labels.length>0?this.formatted_labels:this.labels;this.legend_totals.map(function(a,s){a&&(t.create("div",{className:"stats",inside:e.stats_wrapper}).innerHTML='<span class="indicator">\n\t\t\t\t\t<i style="background: '+e.colors[s]+'"></i>\n\t\t\t\t\t<span class="text-muted">'+i[s]+":</span>\n\t\t\t\t\t"+a+"\n\t\t\t\t</span>")})}}]),a}(at),ht=Math.PI/180,ut=function(i){function a(t){B(this,a);var e=U(this,(a.__proto__||Object.getPrototypeOf(a)).call(this,t));return e.type="pie",e.elements_to_animate=null,e.hoverRadio=t.hoverRadio||.1,e.max_slices=10,e.max_legend_points=6,e.isAnimate=!1,e.startAngle=t.startAngle||0,e.clockWise=t.clockWise||!1,e.mouseMove=e.mouseMove.bind(e),e.mouseLeave=e.mouseLeave.bind(e),e.setup(),e}return R(a,i),I(a,[{key:"setup_values",value:function(){var t=this;this.centerX=this.width/2,this.centerY=this.height/2,this.radius=this.height>this.width?this.centerX:this.centerY,this.slice_totals=[];var e=this.data.labels.map(function(e,i){var a=0;return t.data.datasets.map(function(t){a+=t.values[i]}),[a,e]}).filter(function(t){return t[0]>0}),i=e;if(e.length>this.max_slices){e.sort(function(t,e){return e[0]-t[0]}),i=e.slice(0,this.max_slices-1);var a=0;e.slice(this.max_slices-1).map(function(t){a+=t[0]}),i.push([a,"Rest"]),this.colors[this.max_slices-1]="grey"}this.labels=[],i.map(function(e){t.slice_totals.push(e[0]),t.labels.push(e[1])}),this.legend_totals=this.slice_totals.slice(0,this.max_legend_points)}},{key:"makeArcPath",value:function(t,e){var i=this.centerX,a=this.centerY,s=this.radius,n=this.clockWise;return"M"+i+" "+a+" L"+(i+t.x)+" "+(a+t.y)+" A "+s+" "+s+" 0 0 "+(n?1:0)+" "+(i+e.x)+" "+(a+e.y)+" z"}},{key:"make_graph_components",value:function(t){var e=this,i=this.radius,s=this.clockWise;this.grand_total=this.slice_totals.reduce(function(t,e){return t+e},0);var n=this.slicesProperties||[];this.slices=[],this.elements_to_animate=[],this.slicesProperties=[];var r=180-this.startAngle;this.slice_totals.map(function(o,l){var h=r,u=o/e.grand_total*360,c=s?-u:u,p=r+=c,d=a.getPositionByAngle(h,i),v=a.getPositionByAngle(p,i),f=t&&n[l],m=void 0,g=void 0;t?(m=f?f.startPosition:d,g=f?f.endPosition:d):(m=d,g=v);var y=e.makeArcPath(m,g),x=_(y,"pie-path","none",e.colors[l]);x.style.transition="transform .3s;",e.draw_area.appendChild(x),e.slices.push(x),e.slicesProperties.push({startPosition:d,endPosition:v,value:o,total:e.grand_total,startAngle:h,endAngle:p,angle:c}),t&&e.elements_to_animate.push([{unit:x,array:e.slices,index:e.slices.length-1},{d:e.makeArcPath(d,v)},650,"easein",null,{d:y}])}),t&&this.run_animation()}},{key:"run_animation",value:function(){var t=this;if(this.elements_to_animate&&0!==this.elements_to_animate.length){var e=x(this.svg,this.elements_to_animate);this.svg.parentNode==this.chart_wrapper&&(this.chart_wrapper.removeChild(this.svg),this.chart_wrapper.appendChild(e)),setTimeout(function(){e.parentNode==t.chart_wrapper&&(t.chart_wrapper.removeChild(e),t.chart_wrapper.appendChild(t.svg))},650)}}},{key:"calTranslateByAngle",value:function(t){var e=this.radius,i=this.hoverRadio,s=a.getPositionByAngle(t.startAngle+t.angle/2,e);return"translate3d("+s.x*i+"px,"+s.y*i+"px,0)"}},{key:"hoverSlice",value:function(t,i,a,s){if(t){var n=this.colors[i];if(a){y(t,this.calTranslateByAngle(this.slicesProperties[i])),t.style.fill=S(n,50);var r=e(this.svg),o=s.pageX-r.left+10,l=s.pageY-r.top-10,h=(this.formatted_labels&&this.formatted_labels.length>0?this.formatted_labels[i]:this.labels[i])+": ",u=(100*this.slice_totals[i]/this.grand_total).toFixed(1);this.tip.set_values(o,l,h,u+"%"),this.tip.show_tip()}else y(t,"translate3d(0,0,0)"),this.tip.hide_tip(),t.style.fill=n}}},{key:"mouseMove",value:function(t){for(var e=t.target,i=this.curActiveSliceIndex,a=this.curActiveSlice,s=0;s<this.slices.length;s++)if(e===this.slices[s]){this.hoverSlice(a,i,!1),this.curActiveSlice=e,this.curActiveSliceIndex=s,this.hoverSlice(e,s,!0,t);break}}},{key:"mouseLeave",value:function(){this.hoverSlice(this.curActiveSlice,this.curActiveSliceIndex,!1)}},{key:"bind_tooltip",value:function(){this.draw_area.addEventListener("mousemove",this.mouseMove),this.draw_area.addEventListener("mouseleave",this.mouseLeave)}},{key:"show_summary",value:function(){var e=this,i=this.formatted_labels&&this.formatted_labels.length>0?this.formatted_labels:this.labels;this.legend_totals.map(function(a,s){var n=e.colors[s];a&&(t.create("div",{className:"stats",inside:e.stats_wrapper}).innerHTML='<span class="indicator">\n\t\t\t\t\t<i style="background-color:'+n+';"></i>\n\t\t\t\t\t<span class="text-muted">'+i[s]+":</span>\n\t\t\t\t\t"+a+"\n\t\t\t\t</span>")})}}],[{key:"getPositionByAngle",value:function(t,e){return{x:Math.sin(t*ht)*e,y:Math.cos(t*ht)*e}}}]),a}(at),ct=function(t){function e(t){var i=t.start,a=void 0===i?"":i,s=t.domain,n=void 0===s?"":s,r=t.subdomain,o=void 0===r?"":r,l=t.data,h=void 0===l?{}:l,u=t.discrete_domains,c=void 0===u?0:u,_=t.count_label,p=void 0===_?"":_,d=t.legend_colors,v=void 0===d?[]:d;B(this,e);var f=U(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,arguments[0]));f.type="heatmap",f.domain=n,f.subdomain=o,f.data=h,f.discrete_domains=c,f.count_label=p;var m=new Date;return f.start=a||H(m,365),v=v.slice(0,5),f.legend_colors=f.validate_colors(v)?v:["#ebedf0","#c6e48b","#7bc96f","#239a3b","#196127"],f.distribution_size=5,f.translate_x=0,f.setup(),f}return R(e,t),I(e,[{key:"validate_colors",value:function(t){if(t.length<5)return 0;var e=1;return t.forEach(function(t){T(t)||(e=0,console.warn('"'+t+'" is not a valid color.'))},this),e}},{key:"setup_base_values",value:function(){this.today=new Date,this.start||(this.start=new Date,this.start.setFullYear(this.start.getFullYear()-1)),this.first_week_start=new Date(this.start.toDateString()),this.last_week_start=new Date(this.today.toDateString()),7!==this.first_week_start.getDay()&&H(this.first_week_start,-1*this.first_week_start.getDay()),7!==this.last_week_start.getDay()&&H(this.last_week_start,-1*this.last_week_start.getDay()),this.no_of_cols=E(this.first_week_start+"",this.last_week_start+"")+1}},{key:"set_width",value:function(){this.base_width=12*(this.no_of_cols+3),this.discrete_domains&&(this.base_width+=144)}},{key:"setup_components",value:function(){this.domain_label_group=this.makeDrawAreaComponent("domain-label-group chart-label"),this.data_groups=this.makeDrawAreaComponent("data-groups","translate(0, 20)")}},{key:"setup_values",value:function(){var t=this;this.domain_label_group.textContent="",this.data_groups.textContent="";var e=Object.keys(this.data).map(function(e){return t.data[e]});this.distribution=A(e,this.distribution_size),this.month_names=["January","February","March","April","May","June","July","August","September","October","November","December"],this.render_all_weeks_and_store_x_values(this.no_of_cols)}},{key:"render_all_weeks_and_store_x_values",value:function(t){var e=new Date(this.first_week_start);this.week_col=0,this.current_month=e.getMonth(),this.months=[this.current_month+""],this.month_weeks={},this.month_start_points=[],this.month_weeks[this.current_month]=0,this.month_start_points.push(13);for(var i=0;i<t;i++){var a=void 0,s=0,n=new Date(e),r=this.get_week_squares_group(n,this.week_col),o=Y(r,2);a=o[0],s=o[1],this.data_groups.appendChild(a),this.week_col+=1+parseInt(this.discrete_domains&&s),this.month_weeks[this.current_month]++,s&&(this.current_month=(this.current_month+1)%12,this.months.push(this.current_month+""),this.month_weeks[this.current_month]=1),H(e,7)}this.render_month_labels()}},{key:"get_week_squares_group",value:function(t,e){for(var i=this.today.getTime(),a=0,s=0,n=c(this.data_groups,"data-group"),r=0,o=0;o<7;o+=1,r+=12){var l=0,h=0,u=t.getTime()/1e3,_=Math.floor(u-u%86400).toFixed(1);this.data[_]&&(l=this.data[_]),this.data[Math.round(_)]&&(l=this.data[Math.round(_)]),l&&(h=M(l,this.distribution));var p=13+12*(e+s),v={"data-date":j(t),"data-value":l,"data-day":t.getDay()},f=d("day",p,r,10,this.legend_colors[h],v);n.appendChild(f);var m=new Date(t);if(H(m,1),m.getTime()>i)break;m.getMonth()-t.getMonth()&&(a=1,this.discrete_domains&&(s=1),this.month_start_points.push(13+12*(e+s))),t=m}return[n,a]}},{key:"render_month_labels",value:function(){var t=this;this.months.shift(),this.month_start_points.shift(),this.months.pop(),this.month_start_points.pop(),this.month_start_points.map(function(e,i){var a=v("y-value-text",e+12,10,t.month_names[t.months[i]].substring(0,3));t.domain_label_group.appendChild(a)})}},{key:"make_graph_components",value:function(){Array.prototype.slice.call(this.container.querySelectorAll(".graph-stats-container, .sub-title, .title")).map(function(t){t.style.display="None"}),this.chart_wrapper.style.marginTop="0px",this.chart_wrapper.style.paddingTop="0px"}},{key:"bind_tooltip",value:function(){var t=this;Array.prototype.slice.call(document.querySelectorAll(".data-group .day")).map(function(e){e.addEventListener("mouseenter",function(e){var i=e.target.getAttribute("data-value"),a=e.target.getAttribute("data-date").split("-"),s=t.month_names[parseInt(a[1])-1].substring(0,3),n=t.chart_wrapper.getBoundingClientRect(),r=e.target.getBoundingClientRect(),o=parseInt(e.target.getAttribute("width")),l=r.left-n.left+(o+2)/2,h=r.top-n.top-(o+2)/2,u=i+" "+t.count_label,c=" on "+s+" "+a[0]+", "+a[2];t.tip.set_values(l,h,c,u,[],1),t.tip.show_tip()})})}},{key:"update",value:function(t){this.data=t,this.setup_values(),this.bind_tooltip()}}]),e}(at),_t={line:rt,bar:nt,scatter:ot,percentage:lt,heatmap:ct,pie:ut},pt=function t(e){return B(this,t),F(e.type,arguments[0])};return pt}();

/**
 *
 * INIT STAT Object namespace
 *
 */

var stat = {};

/**
 *
 * Commonly Used Elements
 *
 */

stat.el = {
	'html': document.querySelector('html'),
	'body': document.querySelector('body'),
	'header': document.querySelector('header'),
	'main': document.querySelector('main'),
	'article': document.querySelector('article'),
	'aside': document.querySelector('aside'),
	'footer': document.querySelector('footer')
};

 /**
 *
 * contextPath gets the current app path in case the context changes for endpoints
 *
 * @returns {path}
 */

stat.contextPath = function() {
	return window.location.pathname.substring(0, window.location.pathname.indexOf("/",2));
};


/**
 *
 * getUrlParam grabs the parameter of supplied value
 * 
 * @param {String} requestedURIparam
 * @returns {value}
 */

stat.getUrlParam = function(param) {
	var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(window.location.href);
	if (results==null){
	    return null;
	}
	else {
	    return results[1] || 0;
	}
};

/**
 *
 * ready fires callback when the document readyState is 'complete'
 * 
 * @callback {function} callback
 *
 * Reference:
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
 */

stat.ready = function(callback) {
	document.addEventListener('readystatechange', function(event){
		if (event.target.readyState === 'interactive') {
			if (typeof callback == 'function') callback();
		}
	});
};

/**
 *
 * STAT Browser Detection
 * Add class to <html> for IE
 *
 */

stat.browser = {};

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
stat.browser.detect = function() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};

// Get IE or Edge browser version
stat.browser.version = stat.browser.detect();

if (stat.browser.version === false) {
  console.log('Modern Browser');
}
else if (stat.browser.version >= 12) {
  console.log('Edge ' + stat.browser.version);
  stat.el.body.classList.add('msedge');
}
else {
  console.log('IE ' + stat.browser.version);
  stat.el.body.classList.add('msie');
}
/**
 *
 * STAT Lib Hooks
 * Hooking 3rd party libs into the 'stat' namespace
 *
 */


/**
 *
 * stat.cookies remaped from docCookies
 *
 * @returns docCookies
 */
stat.cookies = docCookies;

/**
 *
 * stat.chart remaped from Chart
 *
 * @returns Chart
 */
stat.chart = Chart;
/**
 *
 * STAT Build Tools for Building STAT Template DOM Elements
 *
 */

stat.build = {};


/**
 *
 * Helper method to do a replace all in a string using the provided regex
 *
 * @param {regex} regex The pattern to look for to replace
 * @param {String} replaceWith The string to put in the place of matching items
 * @param {String} str The string the regex pattern will search in
 * @returns {unresolved}
 */

stat.build._replaceAll = function(regex, replaceWith, str) {
	return str.replace(new RegExp(regex, 'g'), replaceWith);
};

/**
 *
 * Builds a element node with no attributes and some display text
 *
 * @param {String} elementType
 * @param {String} displayValue
 * @returns {Element}
 */
stat.build.elementWithText = function (elementType, displayValue) {
	var element = document.createElement(elementType);
	element.appendChild(document.createTextNode(displayValue));
	return element;
};

/**
 *
 * Generic function that will build an element with optional displayText
 * and add attributes to the element based on the map using the map.key
 * as the attribute name and the map.value as the attributes value
 *
 * @param {string} elementToMake
 * @param {Object} elementAttributes
 * @param {string} displayText
 * @returns {Element}
 * example: stat.build.elementWithAttributes('div', {class: "foo", id: "faa"}, 'bar');
 */
stat.build.elementWithAttributes = function(elementToMake, elementAttributes, displayText) {
	var element = document.createElement(elementToMake);

	for (var prop in elementAttributes) {
		element.setAttribute(prop, elementAttributes[prop]);
	}

	if (displayText || displayText === 0) {
		element.appendChild(document.createTextNode(displayText));
	}
	return element;
};

/**
 *
 * Generic function that will append the element as a child to the specified Selector
 *
 * @param {Object} element
 * @param {string} container
 * @param {string} position (optional)
 * example: stat.build.putElement('elementOjbect', 'div.foo');
 */
stat.build.putElement = function(element, container, position) {
	if (typeof(container) != 'object') {
		container = document.querySelector(container);
	}
	if (position === 'top') {
		container.insertAdjacentElement('afterbegin', element);
	}
	else {
		container.appendChild(element);	
	}
};


/**
 *
 * Generic function that will wrap and element with an element
 *
 * @param {Object} element
 * @param {string} container
 * example: stat.build.wrap(document.querySelector('.wrap-me'), document.createElement('div'), 'wrapper');
 */

stat.build.wrap = function(element, wrapper) {
	element.parentNode.insertBefore(wrapper, element);
	wrapper.appendChild(element);
};




/**
 *
 * STAT Form Builders
 * Requires: stat.buildtools.js | stat.build
 *
 */



/**
 *
 * Field Builder
 * Build Fields from a datamap, return to a variable or output
 * @param {Object} fieldmap
 * @param {Object} OPTIONAL data (from xhr.respsonse must match 'datakey': 'foo' in datamap)
 * Returns: [{Fields},]
 * 
 */

stat.build.fieldsFromDataMap = function(fieldmap, data) {

	let fieldsOutput = [];

	// Fields in fieldmap
	for (let i = 0; i < fieldmap.length; i++) {
		
		// Element Type / WhiteList Check
		// Don't allow any elements except in the Arrays below
		let basicElements = ['input', 'select', 'textarea'];
		let advancedElements = ['checkboxGroup', 'radioGroup', 'yesNo'];

		let fieldItems = fieldmap[i],
			fieldAttributes = fieldItems.attr,
			fieldElement = fieldItems.element,
			fieldParentClass = fieldItems.parentClass || false,
			fieldOptions = '',
			fieldCurrentValue = '';

		// Data and Current Values
		if (fieldmap[i].datakey && data) {

			fieldCurrentValue = fieldmap[i].datakey.split('.');
			// 1 levels down
			if (fieldCurrentValue.length == 1) {
				fieldCurrentValue = data[fieldCurrentValue[0]];
			}
			// 2 levels down
			else if (fieldCurrentValue.length == 2) {
				let rootObj = data[fieldCurrentValue[0]];
				if ((typeof rootObj) == 'object') {
					fieldCurrentValue = rootObj[fieldCurrentValue[1]];
				}
			}

		}

		// Basic whitelist Check
		if (basicElements.includes(fieldElement)) {
			// Elements
			let p = document.createElement('p');
			if (fieldParentClass) p.className = fieldParentClass;

			let label = stat.build.elementWithAttributes('label', {for: fieldAttributes.name}, null);
			let labelText = document.createTextNode(fieldItems.label);
			let input = stat.build.elementWithAttributes(fieldElement, fieldAttributes, null);

			// IF input
			if (fieldElement == 'input' && fieldCurrentValue) {
				// If Date, format ISO (valueAsDate)
				if (fieldAttributes.type == 'date') {
					let dateVal = new Date(fieldCurrentValue);
					input.valueAsDate = dateVal;
				}
				else {
					input.value = fieldCurrentValue;
				}
			}
			// IF textarea
			if (fieldElement == 'textarea' && fieldCurrentValue) {
				input.value = fieldCurrentValue;
			}

			// IF select w/ options
			if (fieldElement == 'select') {
				fieldOptions = fieldItems.options;

				for (let o in fieldOptions) {
					let optionItem = stat.build.elementWithAttributes('option', {'value': fieldOptions[o]}, o);
					if (fieldCurrentValue == fieldOptions[o]) optionItem.selected = true;

					input.appendChild(optionItem);
				}
			}

			// If Input Type checkbox single)
			if (fieldAttributes.type == 'checkbox') {
				label.classList.add('inline');
				label.appendChild(input);
				label.appendChild(labelText);
				p.appendChild(label);
			}
			// Normal...
			else {
				if (fieldItems.label) {
					label.appendChild(labelText);
					p.appendChild(label);
				}
				p.appendChild(input);
			}
			// Field Instructions (deprecate in 2.0, see fieldItems.subtext)
			if (fieldItems.instructions) {
				let instructions = stat.build.elementWithAttributes('span', {class: 'instructions'}, fieldItems.instructions);
				p.appendChild(instructions);
			}
			// Subtext Field Helpers (instructions, error, success, optional)
			// whitelist classes:
			let subtextClasses = ['instructions', 'error', 'success', 'optional'];
			if (fieldItems.subtext && (subtextClasses.includes(fieldItems.subtext.class))) {
				let subtext = stat.build.elementWithAttributes('span', {class: fieldItems.subtext.class}, fieldItems.subtext.text);
				p.appendChild(subtext);
			}

			fieldsOutput.push(p);

		}
		else if (advancedElements.includes(fieldElement)) {

			let pClass = 'radioGroup';
			if (fieldElement === 'yesNo') pClass = 'yesNo';
			if (fieldParentClass) pClass = pClass + ' ' + fieldParentClass;

			let p = stat.build.elementWithAttributes('p', {class: pClass}, null);
			let spanQ = stat.build.elementWithAttributes('span', {class: 'question'}, fieldItems.label);
			let spanA = stat.build.elementWithAttributes('span', {class: 'answers'}, null);
			
			fieldOptions = fieldItems.options;
			for (let option in fieldOptions) {

				const uniqueId = `${fieldAttributes.name}-${fieldOptions[option]}`;

				let opLabel = stat.build.elementWithAttributes('label', {'for': uniqueId}, null);
				if (fieldElement === 'yesNo') opLabel.classList.add('inline');

				let opText = document.createTextNode(option);
				let opInput = stat.build.elementWithAttributes(
					'input',
					{
						'value': fieldOptions[option],
						'type': fieldAttributes.type,
						'name': fieldAttributes.name,
						'id': uniqueId
					},
					null
				);

				if (fieldAttributes.class) opInput.classList.add(fieldAttributes.class);

				if (typeof fieldCurrentValue == 'object') {
					for (let i = 0, length1 = fieldCurrentValue.length; i < length1; i++) {
						if (fieldCurrentValue[i] == fieldOptions[option]) opInput.checked = true;
					}
				}
				else {
					if (fieldCurrentValue == fieldOptions[option]) opInput.checked = true;	
				}
				

				opLabel.appendChild(opInput);
				opLabel.appendChild(opText);
				spanA.appendChild(opLabel);
			}
			// Eat glue
			p.appendChild(spanQ);
			p.appendChild(spanA);

			fieldsOutput.push(p);

		} // if advancedElements
		
	} // for fieldmap

	return fieldsOutput;

};

/**
 *
 * Button Builder
 * Build Buttons from a datamap, return to a variable or output
 * @param {Object} buttonmap
 * Returns: elementObject
 * 
 */

stat.build.buttonsFromDataMap = function(buttonnmap) {
	let buttonP = stat.build.elementWithAttributes('p', {class: 'buttons'}, null);

	for (let i = 0; i < buttonnmap.length; i++) {
		
		let buttonItems = buttonnmap[i],
			buttonTitle = buttonItems.title,
			buttonAttributes = buttonItems.attr,
			buttonElement = buttonItems.element;

		let button = stat.build.elementWithAttributes(buttonElement, buttonAttributes, buttonTitle);

		buttonP.appendChild(button);
	}
	return buttonP;
};


/**
 * 
 * Form Fieldset Builder with (optional) Title and (optional) Buttons
 * 
 * Utilize 'element with attributes' function to build this set *
 * @param {Object} fieldmap
 * @param {Object} data (from xhr, optional, must match 'datakey': 'foo' in datamap)
 * 
 * Name, InputType, ClassList, Title, Placeholder, Required, 
 * 
 */

stat.build.fieldset = function(title, fieldmap, data) {
	
	// Check for fieldmap
	if (!fieldmap) {
		console.error('fieldmap Object Required');
		return;
	}

	let fieldset = document.createElement('fieldset');
	
	// Fieldset Title
	let fieldsetLegend = stat.build.elementWithText('legend', null);
	if (title) {
		fieldsetLegend.innerText = title;
		fieldset.appendChild(fieldsetLegend);
	}

	// Build Fields and append | stat.build.fieldsFromDataMap()
	let fieldsOutput = stat.build.fieldsFromDataMap(fieldmap.fields, data);
	for(var i = 0, length1 = fieldsOutput.length; i < length1; i++){
		fieldset.appendChild(fieldsOutput[i]);
	}
	
	// Setup Fieldset Buttons (if defined)
	// Inserts into <legend>
	if (fieldmap.legendButtons && title) {

		let allowdElements = ['a', 'button'];

		for (let i = 0, length1 = fieldmap.legendButtons.length; i < length1; i++) {
			let lBtn = fieldmap.legendButtons[i];
			if (allowdElements.includes(lBtn.element)) {
				let lBtnEl = stat.build.elementWithAttributes(lBtn.element, lBtn.attr, lBtn.text);
				lBtnEl.classList.add('button');
				fieldsetLegend.appendChild(lBtnEl);
			}
			else {
				let lBtnEl = stat.build.elementWithAttributes('a', lBtn.attr, lBtn.text);
				lBtnEl.classList.add('button');
				fieldsetLegend.appendChild(lBtnEl);
			}			
		}
	}

	// Build Buttons in fieldmap (if defined)
	// Inserts at bottom of fieldset
	if (fieldmap.buttons) {
		let buttonsOutput = stat.build.buttonsFromDataMap(fieldmap.buttons);
		buttonsOutput.classList.add('fieldset-end');
		fieldset.appendChild(buttonsOutput);
	}
	
	return fieldset;
};
/**
 *
 * STAT AJAX Tools
 * https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
 * https://developer.mozilla.org/en-US/docs/AJAX/Getting_Started
 *
 * Interesting
 * https://stackoverflow.com/questions/8567114/how-to-make-an-ajax-call-without-jquery
 * https://www.html5rocks.com/en/tutorials/file/xhr2/
 * https://gist.github.com/EtienneR/2f3ab345df502bd3d13e
 *
 */

stat.ajax = {};


// <meta name="_csrf_header" content="X-CSRF-TOKEN">
// <meta name="_csrf" content="TEST--4b22f3d0-2765-45f4-beaf-2f268debe137">
// https://github.com/madmurphy/cookies.js

stat.ajax.csrf = {
	set: function(name, value) {
		if (name == null) name = 'X-CSRF-TOKEN';
		if (value == null) value = 'TEST--4b22f3d0-2765-45f4-beaf-2f268debe137';
		stat.cookies.setItem(name, value);
	},
	get: function(name) {
		console.log(stat.cookies.getItem(name));
	}
};


stat.ajax.req = function(verb, url, params, callback, onerror) {
	if (verb == undefined || verb == null) verb = 'POST';

	let customHeaders = false;
	let customResponseType = false;

	// Setup Custom Headers and Response Types
	if (typeof params == 'object') {
		if (params instanceof FormData) {
			if (params.get('setRequestHeader')) {
				customHeaders = JSON.parse(params.get('setRequestHeader'));
				params.delete('setRequestHeader');
			}

			if (params.get('responseType')) {
				customResponseType = JSON.parse(params.get('responseType'));
				params.delete('responseType');
			}
		} else {
			// Check for setRequestHeader in params
			if ('setRequestHeader' in params) {
				customHeaders = params.setRequestHeader;
				delete params['setRequestHeader'];
			}

			// Check for responseType in params
			if ('responseType' in params) {
				customResponseType = params.responseType;
				delete params['responseType'];
			}	
		}
	} // object check

	// Whitelist - only allow 'POST', 'PUT', 'DELETE', 'PATCH'
	const wl = ['POST', 'PUT', 'DELETE', 'PATCH'];

	if (wl.indexOf(verb) != -1) {

		// start xmlhttprequest
		let xhr = new XMLHttpRequest();

		// xhr.withCredentials = true;
		xhr.addEventListener('readystatechange', function () {
			if (this.readyState === this.DONE) {
				if (typeof callback == 'function') callback(xhr);
			}
		});

		xhr.addEventListener('error', function(err) {
		  if (typeof onerror == 'function') onerror(err);
		});

		xhr.open(verb, url);

		xhr.responseType = customResponseType || 'json';

		// Check as FormData() [if FormData, do nothing]
		if (!(params instanceof FormData)) {
			// Default behavior
			params = JSON.stringify(params);
			// Normal Headers
			xhr.setRequestHeader('content-Type', 'application/JSON');
			// xhr.setRequestHeader('x-Requested-With', 'XMLHttpRequest');
		}

		// Custom Headers
		if (customHeaders) {
			for (let header in customHeaders) {
				xhr.setRequestHeader(header, customHeaders[header]);
			}
		}
		
		// CSRF Header
		if (stat.cookies.hasItem('X-CSRF-TOKEN')) xhr.setRequestHeader('X-CSRF-TOKEN', stat.cookies.getItem('X-CSRF-TOKEN'));
		// Authorization Header (ACCOUNT)
		if (stat.account.check()) {
			var uiijwt = account.storage.get();
			if (uiijwt !== null) xhr.setRequestHeader('Authorization', 'Bearer ' + uiijwt);
		}

		xhr.send(params);
	}
};

// Shorthand Verbs:
stat.ajax.post = function(url, params, callback, onerror) {
	stat.ajax.req('POST', url, params, callback, onerror);
};
stat.ajax.put = function(url, params, callback, onerror) {
	stat.ajax.req('PUT', url, params, callback, onerror);
};
stat.ajax.patch = function(url, params, callback, onerror) {
	stat.ajax.req('PATCH', url, params, callback, onerror);
};
stat.ajax.delete = function(url, params, callback, onerror) {
	stat.ajax.req('DELETE', url, params, callback, onerror);
};

/**
 *
 * stat.ajax.get
 * @param {string} url : path to endpoint
 * @param {object} params : params to send in URL
 * @callback {function} callback to run when readyState === 4 (DONE)
 *
 */

stat.ajax.get = function(url, params, callback, onerror) {

	let customHeaders = false;
	let customResponseType = false;

	if (typeof params == 'object') {

		// Check for setRequestHeader in params
		if ('setRequestHeader' in params) {
			console.log('params.setRequestHeader:', params['setRequestHeader']);
			customHeaders = params.setRequestHeader;
			delete params['setRequestHeader'];
		}

		// Check for responseType in params
		if ('responseType' in params) {
			console.log('params.responseType:', params['responseType']);
			customResponseType = params.responseType;
			delete params['responseType'];
		}
	} // object check

	// Send Params to String
	let str = '';
	if (typeof params === 'object') {
		// loop through objects/keys
		for (let key in params) {
			if (str != '') {
				str += '&';
			}
			if (typeof params[key] === 'object') {
				// Convert to stringfied thing
				str += key + '=' + encodeURIComponent(JSON.stringify(params[key]));
			} else {
				// Default behavior
				str += key + '=' + encodeURIComponent(params[key]);
			}
		}
	}

	if (str.length >= 1) url = url.concat('?', str);

	// start xmlhttprequest
 	let xhr = new XMLHttpRequest();

	// xhr.withCredentials = true;

	xhr.addEventListener('readystatechange', function () {
		if (this.readyState === this.DONE) {
			if (typeof callback == 'function') callback(xhr);
		}
	});

	xhr.addEventListener('error', function(err) {
	  if (typeof onerror == 'function') onerror(err);
	});

	xhr.open('GET', url);

	xhr.responseType = customResponseType || 'json';
	// xhr.timeout = 6000;

	// Normal Headers
	xhr.setRequestHeader('Content-Type', 'application/JSON');
	// xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	// Custom Headers

	if (customHeaders) {
		for (let header in customHeaders) {
			xhr.setRequestHeader(header, customHeaders[header]);
		}
	}
	// CSRF Header
	if (stat.cookies.hasItem('X-CSRF-TOKEN')) xhr.setRequestHeader('X-CSRF-TOKEN', stat.cookies.getItem('X-CSRF-TOKEN'));
	// Authorization Header (ACCOUNT)
	if (stat.account.check()) {
		let uiijwt = account.storage.get();
		if (uiijwt !== null) xhr.setRequestHeader('Authorization', 'Bearer ' + uiijwt);
	}

	xhr.send();
};
stat.isPage = function(pageTitle) {
	var title = document.getElementsByTagName('title')[0];
	var siteName = title.getAttribute('data-title');
	var titleText = title.innerText;

	pageTitle += ' | ' + siteName;

	if (pageTitle === titleText) {
		return true;
	}
	else {
		return false;
	}
};
/**
 * STAT Navigation Functions
 */

stat.nav = {};


/**
 * Add Mobile Menu Btns into DOM and view
 * 
 */
stat.nav.addButtons = function() {
	var header_hnav = {
		container: stat.build.elementWithAttributes('div', {class: "hnav"}, null),
		button: stat.build.elementWithAttributes('button', {type: "button", class: "hnav--open"}, 'Menu')
	}
	
	var footer_hnav = {
		container: stat.build.elementWithAttributes('div', {class: "hnav"}, null),
		button: stat.build.elementWithAttributes('button', {type: "button", class: "hnav--close"}, 'Menu')
	}

	header_hnav.container.appendChild(header_hnav.button);
	footer_hnav.container.appendChild(footer_hnav.button);
	
	stat.build.putElement(header_hnav.container, stat.el.header);
	if (stat.el.aside) stat.build.putElement(footer_hnav.container, stat.el.aside, 'top');
};

stat.nav.addButtons();


/**
 *
 * VARS
 *
 * @returns
 */

stat.nav.openBtn = document.querySelector('button.hnav--open');
stat.nav.closeBtn = document.querySelector('button.hnav--close');
stat.nav.aside = document.querySelector('aside');

stat.nav.toggle = function(e) {
	if (e.target == stat.nav.openBtn) {
		stat.nav.aside.classList.remove('closed');
	}
	else if (e.target == stat.nav.closeBtn) {
		stat.nav.aside.classList.add('closed');
	}
	else {
		stat.nav.aside.classList.toggle('closed');	
	}
};


// Listeners
stat.nav.openBtn.addEventListener('click', stat.nav.toggle, false);
if (stat.nav.closeBtn) stat.nav.closeBtn.addEventListener('click', stat.nav.toggle, false);

// Add Closed when loaded
if (stat.nav.aside) stat.nav.aside.classList.add('closed');
/**
 *
 * STAT Modal Tools
 * 
 *
 */

stat.modal = {};

/**
 * Modal Builder
 *
 * type: dialog, loading
 * returns modal
 * 
 */

stat.modal.builder = {
	dialog: function(args) {
		var type = args.type 				|| 'dialog',
			size = args.size 				|| 'medium',
			style = args.style 				|| '',
			title = args.title 				|| 'Notice',
			body = args.body 				|| '',
			buttons = args.buttons			|| [],
			dismissable = args.dismissable;
			// make dismissable true by default:
			if (dismissable === undefined) dismissable = true;

		var modalClassList = 'modal ' + style + ' ' + size;

		// Create Modal Container
		var modal = stat.build.elementWithAttributes('div', {class: modalClassList, role: 'dialog'}, null);
		// Create Modal Header
		var modalHeader = stat.build.elementWithAttributes('div', {class: "modal-header"}, null);
		var modalHeaderTitle = stat.build.elementWithText('h4', title);
		var modalHeaderClose = stat.build.elementWithAttributes('button', {class: 'modal-close'}, 'Close');
		// Listen for Close
		if (dismissable) modalHeaderClose.addEventListener('click', stat.modal.destroy, false);
		// Append Header To Modal
		modalHeader.appendChild(modalHeaderTitle);
		if (dismissable) modalHeader.appendChild(modalHeaderClose);
		modal.appendChild(modalHeader);
		// Create Modal Body
		var modalBody = stat.build.elementWithAttributes('div', {class: 'modal-body'}, null);
		for (var i = 0; i < body.length; i++) {
			var modalBodyParagraph = stat.build.elementWithText('p', body[i]);
			modalBody.appendChild(modalBodyParagraph);
		}
		// Append Body To Modal
		modal.appendChild(modalBody);
		// Create Modal Footer
		var modalFooter = stat.build.elementWithAttributes('div', {class: 'modal-footer'}, null);
		for (var i = 0; i < buttons.length; i++) {
			var buttonTitle = buttons[i].title || 'Button',
				buttonHref = buttons[i].href || undefined,
				buttonStyle = buttons[i].style || '',
				buttonCallback = buttons[i].callback || '',
				buttonTag = 'button',
				buttonDownload = buttons[i].download || undefined,
				buttonId = i;
			// Button Tag Check
			if (buttonHref) buttonTag = 'a';
			// Setup Attributes stringify then parse to remove undfined :)
			var buttonAttributes = {
				class: 'btn ' + buttonStyle,
				type: (buttonHref ? undefined : 'button'),
				href: (buttonHref ? buttonHref : undefined),
				download: (buttonDownload ? buttonDownload : undefined),
				id: 'modalButton-' + buttonId
			}
			// Build Button
			var modalButton = stat.build.elementWithAttributes(buttonTag, JSON.parse(JSON.stringify(buttonAttributes)), buttonTitle);
			// Setup Callback if avail
			if (typeof buttonCallback == 'function') {
				modalButton.addEventListener('click', buttonCallback, false);
			}
			else if (buttonCallback === 'destroy') {
				modalButton.addEventListener('click', stat.modal.destroy, false);
			}
			modalFooter.appendChild(modalButton);
		}
		modal.appendChild(modalFooter);
		return modal;
	},
	loading: function(args) {
		var type = args.type 					|| 'loading',
			size = args.size 					|| 'medium',
			style = args.style 					|| ''
			title = args.title 					|| 'Loading',
			dismissable = args.dismissable;
			// make dismissable true by default:
			if (dismissable === undefined) dismissable = true;

		var modalClassList = 'modal loading' + style + ' ' + size;

		// Create Modal Container
		var modal = stat.build.elementWithAttributes('div', {class: modalClassList, role: 'dialog'}, null);
		// Create Modal Header
		var modalHeader = stat.build.elementWithAttributes('div', {class: "modal-header"}, null);
		var modalHeaderTitle = stat.build.elementWithText('h4', title);
		var modalHeaderClose = stat.build.elementWithAttributes('button', {class: 'modal-close'}, 'Close');
		// Listen for Close
		if (dismissable) modalHeaderClose.addEventListener('click', stat.modal.destroy, false);
		// Append Header To Modal
		modalHeader.appendChild(modalHeaderTitle);
		if (dismissable) modalHeader.appendChild(modalHeaderClose);
		modal.appendChild(modalHeader);
		// Create Modal Body
		var modalBody = stat.build.elementWithAttributes('div', {class: 'modal-body'}, null);
		var modalLoadingSpan = stat.build.elementWithAttributes('span', {class: 'stat-loading', 'data-type': 'bar'}, null);
		// Append Body To Modal
		modalBody.appendChild(modalLoadingSpan);
		modal.appendChild(modalBody);
		// Append Body To Modal
		modal.appendChild(modalBody);

		return modal;
	}
};

/**
 * MODAL ARGS: {}
 *
 * type: dialog, confirm, loading, message (default)
 * size: small, medium (default), large
 * style: default, error, success, alert, money, print, download
 * overlay: default, blackout
 * title: 'string'
 * body: ['lorem ipsum', 'second paragraph']
 * buttons: [{title: 'foo', style: 'submit', callback: 'success()'},...]
 * dismissable: bool (default: true)
 * 
 */

stat.modal.create = function(args) {

	// Set Type
	switch (args.type) {
		case 'loading':
			var modal = stat.modal.builder.loading(args);
			break;
		default:
			var modal = stat.modal.builder.dialog(args);
			break;
	}
	
	// Place Element in Body
	stat.modal.overlay(args.overlay);
	stat.build.putElement(modal, 'body');

};

/**
 *
 * Create Overlay
 *
 * @param {String} option: normal (default) || blackout
 * 
 */

stat.modal.overlay = function(option) {
	var existing = document.querySelectorAll('.modal-overlay');
	for (var i = 0; i < existing.length; i++) {
		existing[i].parentNode.removeChild(existing[i]);
	}
	var overlay = stat.build.elementWithAttributes('div', {class: "modal-overlay"}, null);
	// If option class
	if (option != undefined) overlay.classList.add(option);

	stat.build.putElement(overlay, 'body');
};

/**
 *
 * Destroy All Modals and Overlays
 *
 * 
 */

stat.modal.destroy = function() {
	var modals = document.querySelectorAll('.modal');
	var overlays = document.querySelectorAll('.modal-overlay');
	for (var i = 0; i < modals.length; i++) {
		modals[i].parentNode.removeChild(modals[i]);
	}
	for (var i = 0; i < overlays.length; i++) {
		overlays[i].parentNode.removeChild(overlays[i]);
	}
};

/**
 *
 * Show or Hide existing Modals
 *
 * @param {String} option: show || hide
 * 
 */

stat.modal.display = function(option, modal) {

	var modals = document.querySelectorAll('.modal');
	var overlays = document.querySelectorAll('.modal-overlay');

	if (option === 'hide') {
		for (var i = 0; i < modals.length; i++) {
		modals[i].classList.add('hidden');
		}
		for (var i = 0; i < overlays.length; i++) {
			overlays[i].classList.add('hidden');
		}
	}
	if (option === 'show') {
		for (var i = 0; i < modals.length; i++) {
		modals[i].classList.remove('hidden');
		}
		for (var i = 0; i < overlays.length; i++) {
			overlays[i].classList.remove('hidden');
		}
	}
	
};









/**
 *
 * STAT Message Tools
 * 
 *
 */

stat.message = {};

/**
 * Message Builder
 *
 * type: message, loading
 * returns message
 * 
 */


stat.message.builder = {
	message: function(args) {
		var type = args.type 				|| 'message',
			style = args.style 				|| '',
			title = args.title 				|| 'Notice',
			body = args.body 				|| '',
			buttons = args.buttons			|| [],
			timeout = args.timeout 			|| 'none'
			dismissable = args.dismissable 	|| false;

		var messageClassList = 'message ' + style;
		// Create Message Container
		var message = stat.build.elementWithAttributes('div', {class: messageClassList, role: 'dialog'}, null);
		var messageTitle = stat.build.elementWithText('h3', title);
		var messageClose = stat.build.elementWithAttributes('button', {class: 'message-close'}, 'Close');
		// Listen for Close
		if (dismissable) messageClose.addEventListener('click', stat.message.destroy, false);
		// Append Header To Message
		if (dismissable) messageTitle.appendChild(messageClose);
		message.appendChild(messageTitle);
		// Create Message Paragraphs
		for (var i = 0; i < body.length; i++) {
			var messageParagraph = stat.build.elementWithText('p', body[i]);
			message.appendChild(messageParagraph);
		}
		var messageButtons = document.createElement('p');
		// Create Message Buttons
		for (var i = 0; i < buttons.length; i++) {
			var buttonTitle = buttons[i].title 			|| 'Button',
				buttonHref = buttons[i].href 			|| undefined,
				buttonStyle = buttons[i].style 			|| '',
				buttonCallback = buttons[i].callback 	|| '',
				buttonDownload = buttons[i].download 	|| undefined,
				buttonTag = 'button',
				buttonId = i;
			// Button Tag Check
			if (buttonHref) buttonTag = 'a';
			// Setup Attributes stringify then parse to remove undfined :)
			var buttonAttributes = {
				class: 'btn ' + buttonStyle,
				type: (buttonHref ? undefined : 'button'),
				href: (buttonHref ? buttonHref : undefined),
				download: (buttonDownload ? buttonDownload : undefined),
				id: 'messageButton-' + buttonId
			}
			// Build Button
			var messageButton = stat.build.elementWithAttributes(buttonTag, JSON.parse(JSON.stringify(buttonAttributes)), buttonTitle);
			// Setup Callback if avail
			if (typeof buttonCallback === 'function') {
				messageButton.addEventListener('click', buttonCallback, false);
			}
			else if (buttonCallback === 'destroy') {
				messageButton.addEventListener('click', stat.message.destroy, false);
			}
			messageButtons.appendChild(messageButton);
		}
		message.appendChild(messageButtons);
		
		// If Destroy Timer...
		if (!isNaN(timeout)) {
			
			setTimeout(function(){
				message.classList.add('timeout');
			}, timeout);

			setTimeout(function(){
				message.remove();
			}, timeout + 1300);
			
		}
		// Return!
		return message;
	},
	loading: function(args) {
		var type = args.type 				|| 'loading',
			style = args.style 				|| '',
			title = args.title 				|| 'Loading',
			body = args.body 				|| '',
			buttons = args.buttons			|| [],
			timeout = args.timeout 			|| 'none'
			dismissable = args.dismissable 	|| false;

		var messageClassList = 'message loading ' + style;

		// Create Message Container
		var message = stat.build.elementWithAttributes('div', {class: messageClassList, role: 'dialog'}, null);
		var messageTitle = stat.build.elementWithText('h3', title);
		var messageClose = stat.build.elementWithAttributes('button', {class: 'message-close'}, 'Close');
		// Listen for Close
		if (dismissable) messageClose.addEventListener('click', stat.message.destroy, false);
		// Append Header To Message
		if (dismissable) messageTitle.appendChild(messageClose);
		message.appendChild(messageTitle);
		var modalLoadingSpan = stat.build.elementWithAttributes('span', {class: 'stat-loading', 'data-type': 'bar'}, null);
		// Append Body To message
		message.appendChild(modalLoadingSpan);

		return message;
	}
};

 /**
 * MESSAGE ARGS: {}
 *
 * type: message (default), loading, progress
 * style: default, error, success, alert, money, print, download
 * title: 'string'
 * body: ['lorem ipsum', 'second paragraph']
 * buttons: [{title: 'foo', style: 'submit', callback: 'success()'},...]
 * dismissable: bool (default: true)
 * timeout: milliseconds, none (default)
 * 
 */

stat.message.create = function(args, location) {

	// Set Type
	switch (args.type) {
		case 'loading':
			var message = stat.message.builder.loading(args);
			break;
		default:
			var message = stat.message.builder.message(args);
			break;
	}

	if (location === undefined) {
		var breadcrumbs = document.querySelector('nav.breadcrumbs');
		if (breadcrumbs) {
			breadcrumbs.insertAdjacentElement('afterend', message);
		}
		else {
			// Place Element at top of Article
			stat.el.article.insertAdjacentElement('afterbegin', message);
		}
		
	}
	else if (typeof(location) === 'object') {
		location.insertAdjacentElement('afterbegin', message);
	}
	

};


/**
 *
 * Destroy Message
 * 
 */

stat.message.destroy = function(e) {
	e.target.parentElement.parentElement.remove();
};











/**
 *
 * STAT Account Module
 * Requires AccountJS
 *
 */

stat.account = {};
stat.account.user = {};

// #############################################################
//	Check for Accountjs Lib
//	returns bool
// #############################################################

stat.account.check = function(t) {
	switch (t) {
		case undefined:
		case 'lib':
			if (typeof account == 'object') return true;
			else return false;
			break;
		case 'header':
			if (stat.account.container !== null) return true;
			else return false;
			break;
		case 'token':
			return account.storage.check();
			break;
		case 'valid':
			if (stat.account.user.data) return true;
			else return false;
			break;
		case 'https':
			if (location.protocol == 'https:') return true;
			else return false;
			break;
	}
};

// #############################################################
//	Build Stat-Account Module
//	appends Elements
// #############################################################

stat.account.module = function(status, res) {
	
	stat.account.clearModule();

	if (status === 200) {
		// IF validated
		var el = {
			'user': account.build.elementWithAttributes('div', {class: 'account--user'}, null),
			'userSpan': account.build.elementWithAttributes('span', {}, res.userData.firstName + ' ' + res.userData.lastName),
			'actions': account.build.elementWithAttributes('div', {class: 'account--actions'}, null),
			'actionsMyAccount': account.build.elementWithAttributes('button', {type: 'button', target: '_blank', class: 'myaccount'}, 'My Account'),
			'actionsLogout': account.build.elementWithAttributes('button', {type: 'button', class: 'logout'}, 'Logout'),
		}
		// Listeners
		el.actionsLogout.addEventListener('click', stat.account.logout, false);
		el.actionsMyAccount.addEventListener('click', function() {
			var curPath = window.location;
			account.cookies.setItem('returnToUrl', curPath, null, '/', null, true);
			window.location = '/account/secure/myAccount.html';
		}, false);

		el.user.appendChild(el.userSpan);
		el.actions.appendChild(el.actionsMyAccount);
		el.actions.appendChild(el.actionsLogout);
		stat.account.container.appendChild(el.user);
		stat.account.container.appendChild(el.actions);
	}
	else {
		
		var el = {
			'user': account.build.elementWithAttributes('div', {class: 'account--user'}, null),
			'userSpan': account.build.elementWithAttributes('span', {class: 'no-user'}, null),
			'actions': account.build.elementWithAttributes('div', {class: 'account--actions'}, null),
			'actionsLogin': account.build.elementWithAttributes('button', {type: 'button', class: 'account--login'}, 'Log In')
		}
		// Listeners
		el.actionsLogin.addEventListener('click', function(){
			if (stat.account.container.dataset.success != null || stat.account.container.dataset.success != undefined) {
				account.login(function() {
					window.location = stat.account.container.dataset.success;
				});
			}
			else {
				account.login(stat.account.validate);
			}
		}, false);

		el.user.appendChild(el.userSpan);
		el.actions.appendChild(el.actionsLogin);
		stat.account.container.appendChild(el.user);
		stat.account.container.appendChild(el.actions);
	}

};

// #############################################################
//	Clear Stat-Account Module
// #############################################################

stat.account.clearModule = function() {
	stat.account.container.innerHTML = '';
};

// #############################################################
//	Add Loading Animation
// #############################################################

stat.account.loader = {
	add: function() {
		var accountLoader = stat.build.elementWithAttributes('span', {class: 'stat-loading', 'data-type': 'spin', 'data-size': 'small'}, 'Connecting...');
		stat.account.container.appendChild(accountLoader);	
	},
	remove: function() {
		var accountLoader = stat.account.container.querySelector('.stat-loading');
		stat.account.container.removeChild(accountLoader);
	},
	nonhttps: function() {
		var accountLoader = stat.build.elementWithAttributes('span', {class: 'account-message'}, 'Your connection is not secure');
		stat.account.container.appendChild(accountLoader);
	}
};

// #############################################################
//	Response Switches
// #############################################################

stat.account.compute = function(data) {
	switch (data.status) {
		case 503:
			//Service Unavailable
			break;
		case 500:
			//Internal Server Error
			break;
		case 400:
			//Bad Request
			stat.account.module(data.status, data.response);
			if (stat.account.container.dataset.account === 'persist') {
				// Check for Success URL
				if (stat.account.container.dataset.success != null || stat.account.container.dataset.success != undefined) {
					account.login(function() {
						window.location = stat.account.container.dataset.success;
					}, null, false);
				}
				else {
					account.login(stat.account.validate, null, false);
				}
			}
			break;
		case 404:
			//Not Found
			break;
		case 200:
			//OK
			// Add Data to Temp Obj
			stat.account.user.data = data.response.userData;
			// Update Module
			stat.account.module(data.status, data.response);
			break;
	}
};

// #############################################################
//	Validate Response
// #############################################################

stat.account.validate = function() {
	stat.account.loader.add();
	account.validate(stat.account.compute);
};

// #############################################################
//	STAT Specific login - Run default login then valid
//	callback: if specified, use callback instead
// #############################################################

stat.account.login = function(callback) {
	if (typeof callback === 'function') {
		account.login(callback, null, true);
	}
	else {
		account.login(stat.account.validate, null, true);
	}
	
};

// #############################################################
//	Logout - Uses STAT.modal
// #############################################################

stat.account.logout = function() {
	
	var logoutAction = stat.account.container.dataset.logout;

	function finLogout() {
		account.storage.remove();
		stat.account.clearModule();
		// Clear dialog modal
		stat.modal.destroy();
		if (logoutAction.length > 0) {
			window.location = logoutAction;	
		}
		else {
			stat.account.validate();
		}
	}
	// MODAL ARGS
	var args = {
		type: 'dialog',
		title: 'Log Out',
		style: 'alert',
		body: [
			'You are about to log out of this application',
			'Do you wish to continue?'
		],
		buttons: [
			{title: 'Cancel', style: 'back', callback: 'destroy'},
			{title: 'Logout', style: 'submit', callback: finLogout}
		],
		dismissable: true
	}
	stat.modal.create(args);

};

// #############################################################
//	Force Logout
// #############################################################

stat.account.forcelogout = function() {
	
	var logoutAction = stat.account.container.dataset.logout;

	account.storage.remove();
	stat.account.clearModule();

	if (logoutAction.length > 0) {
		window.location = logoutAction;	
	}
	else {
		stat.account.validate();
	}

};

// #############################################################
//	stat.account.ready - don't fire requests until valid users
//	callback - function
// #############################################################

stat.account.ready = function(callback) {
	if (stat.account.check('https') && stat.account.check('valid')) {
		console.log('User is valid');
		callback();
	}
	else if (stat.account.check('https')) {
		console.log('User is not valid');
		var wait = window.setTimeout(function() {
			stat.account.ready(callback);
		}, 1000);
	}
	else {
		console.log('Not HTTPS.')
	}
};


// #############################################################
//	Check for AccountJS lib and Module Container
// #############################################################

// check for lib and headeer data-account
stat.ready(function(){
	stat.account.container = document.getElementById('stat-account');

	if (stat.account.check('lib') && stat.account.check('header') && stat.account.check('https')) {
		stat.account.validate();
	}
	else if (stat.account.check('https') === false) {
		// give message
		stat.account.loader.nonhttps();
	}
});

/**
 *
 * STAT ToolTips
 * 
 *
 */

stat.tooltip = {};

/**
 *
 * Get all Containers
 *
 */
stat.tooltip.tips = document.querySelectorAll('[data-toggle="tooltip"]');


/**
 *
 * Initialize
 *
 */
stat.tooltip.init = function() {
	for (var i = 0; i < stat.tooltip.tips.length; i++) {
		
		var tipTrigger = stat.tooltip.tips[i].dataset.trigger || 'static';
		var tipColor = stat.tooltip.tips[i].dataset.color || 'default';
		var tipPlacement = stat.tooltip.tips[i].dataset.placement || 'top';
		var tipContent = stat.tooltip.tips[i].dataset.content || '!';
		var tipToggle = 'tooltip';
		console.log(tipTrigger);

		// IF INPUT, WRAP WITH CONTAINER (inputs can't have children)
		if (stat.tooltip.tips[i].tagName === 'INPUT') {
			// Create a wrapper for INPUTS
			var wrapper = document.createElement('div');
				wrapper.setAttribute('data-toggle', 'tooltip-wrapper');
				wrapper.setAttribute('data-color', tipColor);
				wrapper.setAttribute('data-trigger', tipTrigger);
				wrapper.setAttribute('data-placement', tipPlacement);
				wrapper.setAttribute('data-content', tipContent);
			// remove data attributes from original input
			stat.tooltip.tips[i].removeAttribute('data-trigger');
			stat.tooltip.tips[i].removeAttribute('data-placement');
			stat.tooltip.tips[i].removeAttribute('data-content');
			// Add listener or display if static
			if (tipTrigger === 'static') {
				stat.tooltip.display(wrapper, true);
			}	
			else {
				stat.tooltip.addListeners(stat.tooltip.tips[i], tipTrigger);	
			}
			// wrap input
			stat.build.wrap(stat.tooltip.tips[i], wrapper);
		}
		else {
			if (tipTrigger === 'static') {
				stat.tooltip.display(stat.tooltip.tips[i], true);
			}	
			else {
				stat.tooltip.addListeners(stat.tooltip.tips[i], tipTrigger);	
			}
			
		}
		
	}
};

/**
 *
 * Add Listeners
 * @param el object
 * @param tipTrigger string event
 *
 */
stat.tooltip.addListeners = function(el, tipTrigger) {
	// if Mouseover (hover)
	if (tipTrigger === 'mouseover' || tipTrigger === 'hover' || tipTrigger === 'mouseenter') {
		el.addEventListener('mouseenter', stat.tooltip.display, false);
		el.addEventListener('mouseleave', stat.tooltip.display, false);
	}
	else if (tipTrigger === 'focus') {
		el.addEventListener('focus', stat.tooltip.display, false);
		el.addEventListener('blur', stat.tooltip.display, false);
	}
	else if (tipTrigger === 'click') {
		el.addEventListener('click', stat.tooltip.display, false);
	}
};


/**
 *
 * Display Tooltip
 * @param e object
 * @param isstatic bool
 *
 */
stat.tooltip.display = function(el, isstatic) {
	if (isstatic === true) {
		el.classList.add('show-tip');
	}
	else {
		var tiptarget = el.currentTarget;
		// Check for INPUT
		if (tiptarget.tagName === 'INPUT') {
			tiptarget = tiptarget.parentElement;
		}
		// CLASS CHECK
		if (tiptarget.classList.contains('show-tip')) {
			tiptarget.classList.remove('show-tip');	
		}
		else {
			tiptarget.classList.add('show-tip');	
		}	
	}
	
};

if (stat.tooltip.tips.length > 0) {
	stat.tooltip.init();	
}


/**
 * STAT field Required Tools
 */

stat.required = {};

/**
 * Get all fields with custom validity data attributes
 */

stat.required.validityInputs = document.querySelectorAll('[data-validity]');

/**
 * Set custom valid message on selected inputs
 */

stat.required.setValidityListeners = function() {
	for (var i = 0; i < stat.required.validityInputs.length; i++) {
		stat.required.validityInputs[i].oninvalid = function(e) {
			if (!e.target.validity.valueMissing) {
				e.target.setCustomValidity(e.target.dataset.validity);	
			}
		}
		stat.required.validityInputs[i].oninput = function(e) {
			e.target.setCustomValidity('');
		}
	}
};

if (stat.required.validityInputs.length) {
	stat.required.setValidityListeners();
}

/**
 *
 * STAT Tables
 *
 */

stat.table = {};


/**
 *
 * WRAP TABLE FOR TABLE-SCROLL-*
 *
 */

stat.table.scrollers = document.querySelectorAll('table.table-scroll');

stat.table.addScroll = function() {
	
	for (var i = 0; i < stat.table.scrollers.length; i++) {
		var classes = 'table-scroll';
		if (stat.table.scrollers[i].classList.contains('horizontal')) classes += ' horizontal';
		if (stat.table.scrollers[i].classList.contains('vertical')) classes += ' vertical';
		var wrapper = stat.build.elementWithAttributes('div', {class: classes}, null);
		stat.build.wrap(stat.table.scrollers[i], wrapper);
	}

};

if (stat.table.scrollers.length > 0) stat.table.addScroll();


/**
 *
 * STAT BLOB Tools
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Blob
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/atob
 *
 */

stat.blob = {};

stat.blob.URL = '';

// Allowed Types
stat.blob.types = {
	'txt': 'text/plain',
	'csv': 'text/csv',
	'pdf': 'application/pdf',
	'jpg': 'image/jpeg',
	'jpeg': 'image/jpeg',
	'gif': 'image/gif',
	'png': 'image/png',
	'webp': 'image/webp',
	'mpeg': 'video/mpeg',
	'webm': 'video/webm'
};

/**
 *
 * Base64 to ByteArray Conversion
 * @Returns byteArray
 *
 */
stat.blob.base64toByteArrays = function(data, sliceSize) {
	sliceSize = sliceSize || 512;

	var byteCharacters = atob(data);
	var byteArrays = [];

	for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		var slice = byteCharacters.slice(offset, offset + sliceSize);

		var byteNumbers = new Array(slice.length);
		for (var i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		var byteArray = new Uint8Array(byteNumbers);

		byteArrays.push(byteArray);
	}
	return byteArrays;

};

/**
 *
 * Convert and Return URL
 *
 */


stat.blob.objectURL = function(args) {

	var decdata = stat.blob.base64toByteArrays(args.encdata);

	if (args.mimetype != undefined) {

		var blobExport = new Blob(decdata, {type: args.mimetype});
		var objectUrl = window.URL.createObjectURL(blobExport);

		return objectUrl;
	}
	else {
		console.log('bad extension or missing blob');
		return;
	}
};

/**
 *
 * Return or provide callback for ObjectURL
 * @Param encdata - 	(required) -	base64 data (USE btoa())
 * @Param extension - 	(required) -	mimetype extension for conversion
 * @Param filename - 	(optional) -	name of file to give User
 * @Param callback - 	(optional)
 * @Returns objectUrl
 *
 */

stat.blob.show = function(encdata, extension, filename, callback) {
	// Defensive MIME check - whitelist
	if (stat.blob.types.hasOwnProperty(extension)) {
		var args = {
			'encdata': encdata,
			'mimetype': (extension ? stat.blob.types[extension] : undefined),
			'filename': (filename ? filename : undefined)
		}

		filename = filename + '.' + extension;

		var objectURL = stat.blob.objectURL(args);
		console.log(objectURL);

		if (typeof callback == 'function') {

			callback(objectURL, filename);

			// setTimeout(function(){
			// 	window.URL.revokeObjectURL(objectURL);
			// },1500);
		}
		else {
			if (filename) {
				return [objectURL, filename];
			}
			else {
				return objectURL;
			}
		}
	} // defensive
	else {
		console.error('stat.blob.show() bad "extension" param');
	}


};

/**
 * STAT Date/Time tools
 */

stat.date = {};

stat.date.patternInputs = document.querySelectorAll('[data-date]');

/**
 *
 * Check for input[type=date] support
 *
 * @returns true [if supported]
 */

stat.date.isSupported = function() {
	var i = document.createElement('input');
	i.setAttribute('type', 'date');
	return i.type !== 'text';
};


/**
 *
 * Convert Dates for storage and native chrome
 *
 * @returns YYYY-MM-DD to MM/DD/YYYY
 */


stat.date.convert = function(date, fmt) {

	if (fmt === 'MM/DD/YYYY' && date.indexOf('-') > 1) {
		var datesplit = date.split('-');
		date = datesplit[1] + '/' + datesplit[2] + '/' + datesplit[0];
		//Returns MM/DD/YYYY
	}
	else if (fmt === 'YYYY-MM-DD' && date.indexOf('/') > 1) {
		var datesplit = date.split('/');
		date = datesplit[2] + '-' + datesplit[0] + '-' + datesplit[1];
		//Returns YYYY-MM-DD
	}
	else {
		console.log('Invalid Date Format');
	}
	return date;

};


/**
 *
 * Toggle ALL Date fields in DOM for storage and native chrome
 *
 * @returns YYYY-MM-DD or MM/DD/YYYY
 */

stat.date.toggleAll = function() {

	if (!stat.date.isSupported()) {
		console.log('date not supported, toggling!');

		var allDates = document.querySelectorAll('input[type="date"]');

		allDates.forEach(function(element, index) {
			if (element.value.length >= 1 && element.value.indexOf('-') > 1) {
				element.value = stat.date.convert(element.value, 'MM/DD/YYYY');
			}
			else if (element.value.length >= 1 && element.value.indexOf('/') > 1) {
				element.value = stat.date.convert(element.value, 'YYYY-MM-DD');
			}
		});

	} else {
		console.log('date supported, nothing toggled :)');
	}

};


/**
 *
 * Apply HTML5 Pattern Validation to Date Fields, best for non-datepicker browsers
 * @param selector		Object
 * @param pattern 		String [MM/DD/YYYY, YYYY-MM-DD]
 * @param placeholder 	Bool
 * @returns setAttribute(s) to specified selector
 */

stat.date.applyPattern = function(selector, pattern, placeholder) {
	switch (pattern) {
	  case 'MM/DD/YYYY':
	    selector.setAttribute('pattern', '(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\\d\\d');
	    if (placeholder) selector.setAttribute('placeholder', 'MM/DD/YYYY');
	    break;
	  case 'YYYY-MM-DD':
	    selector.setAttribute('pattern', '(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))');
	    	if (placeholder) selector.setAttribute('placeholder', 'YYYY-MM-DD');
	    break;
	  default:
	    console.log('Pattern: ' + pattern + ' not available');
	}
};


stat.date.detectPatternInputs = function() {
	for (var i = 0; i < stat.date.patternInputs.length; i++) {
		stat.date.applyPattern(stat.date.patternInputs[i], stat.date.patternInputs[i].dataset.date, true);
	}
}

if (stat.date.patternInputs.length > 0 && !stat.date.isSupported()) {
	stat.date.detectPatternInputs();
}


stat.font = {};


/**
 *
 * Font Settings Init
 *
 */

stat.font.buttons = document.querySelectorAll('button.fontsize');

stat.font.update = function() {
	var size = localStorage.getItem('fontsize');
	var htmltag = document.getElementsByTagName('html')[0];
	htmltag.className = '';
	switch (size) {
		case 'smallFont':
			htmltag.classList.add('smallFont');
			break;
		case 'largeFont':
			htmltag.classList.add('largeFont');
			break;
		default:
			htmltag.className = '';
			break;
	}
};

stat.font.buttonUpdate = function() {
	for(var i = 0, length1 = stat.font.buttons.length; i < length1; i++){

		if (stat.font.buttons[i].dataset.size == localStorage.getItem('fontsize')) {
			stat.font.buttons[i].classList.add('active');
		}
		else {
			stat.font.buttons[i].classList.remove('active');
		}
	}
};

stat.font.init = function() {
	var settings = localStorage.getItem('fontsize');

	for(var i = 0, length1 = stat.font.buttons.length; i < length1; i++){
		stat.font.buttons[i].addEventListener('click', function(e){
			localStorage.setItem('fontsize', e.currentTarget.dataset.size);
			stat.font.buttonUpdate();
			stat.font.update();
		}, false);
	}
	stat.font.buttonUpdate();
	stat.font.update();
};

stat.font.init();

/**
 * 
 *  STAT Aside Methods
 * 
 */

stat.aside = {};

// container object is already set as stat.el.aside;

stat.aside.setcurrent = function(page) {
	var navitems = stat.el.aside.querySelectorAll('nav li');

	for (var i = 0, length1 = navitems.length; i < length1; i++){
		if (navitems[i].dataset.page === page) {
			navitems[i].classList.add('current');
		}
	}
}

if (stat.el.aside) {
	var currentpage = stat.el.aside.dataset.currentpage;
	if (currentpage) stat.aside.setcurrent(currentpage);
}



